/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Abstract base class for Assessment model
 * This is the return type of the APIs that return an assessment
 * With this we can have SwaggerSubType attribute to generate the correct swagger documentation
 */
export interface AbstractAssessment {
  /** The item type name. Should be overriden by the derived classes */
  itemTypeName?: string;
  /**
   * ExternalID of the patient
   * @format string
   */
  patientId: string;
  /** ETag */
  eTag?: string | null;
  /** Audit information */
  audit: AuditInformation;
  /** States representing the lifecycle of an assessment */
  assessmentState: AssessmentState;
  /** ID of the site where the visit took place */
  siteId: string;
  /** The full room ID including the site ID prefix */
  fullRoomId: string;
  /**
   * The ID of the visit that the assessment is associated with
   * @format uuid
   */
  visitId: string;
  /**
   * The ID of the Scan that the assessment is associated with
   * @format uuid
   */
  scanId: string;
  /**
   * The version of the Scan that the assessment is associated with
   * @format uuid
   */
  scanVersion: string;
  /** Patient Group IDs that the assessment is associated with */
  patientGroupIds: string[];
  /** Represents a DTO summary of a patient denormalized */
  patientSummary?: PatientSummary;
  /**
   * true for the document with ID {ItemTypeName}_{ItemId}_latest
   * true for the document with the same version as the _latest doc
   */
  isLatestVersion: boolean;
  /**
   * ID of the assessment
   * @format uuid
   */
  itemId: string;
  /**
   * Version of the assessment
   * @format uuid
   */
  itemVersion: string;
  /** A free-text supplied by an operator */
  comment?: string | null;
  /**
   * Created At
   * @format date-time
   */
  createdAt: string;
}

/** Envelope for paginated responses */
export interface AbstractAssessmentPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: (PadAssessment | PulseWaveAssessment | ThermalAssessment)[];
}

/** Indicates what state an annotation is in. Useful both for a UI in filtering / determining what to visualize, but also for ML purposes. */
export enum AcceptState {
  Proposed = "proposed",
  Accepted = "accepted",
  Rejected = "rejected",
}

/** Address object, used in the Site object */
export interface Address {
  /** Street name */
  street: string;
  /** City */
  city: string;
  /** State */
  state: string;
  /** Postal Code */
  postalCode: string;
  /** Country */
  country: string;
  /** Country code Alpha 2, ie SE, GB */
  countryCode?: string | null;
  /** GPS Coordinates object, used in the Address object */
  gpsCoordinates: GPSCoordinates;
  /** Name of the address to help Maps to show it correctly. Used for localized names ie "Neko Health Center" */
  name?: string;
}

export enum AdverseEventActionTaken {
  Nothing = "nothing",
  ScanStopped = "scanStopped",
  TreatmentGivenToAE = "treatmentGivenToAE",
  DiscontinuedFromStudy = "discontinuedFromStudy",
}

export enum AdverseEventOutcome {
  Resolved = "resolved",
  ResolvedWithSequelae = "resolvedWithSequelae",
  Ongoing = "ongoing",
  Death = "death",
}

export interface AdverseEventReport {
  /**
   * Date of the adverse event report, filled from Slot/Visit's date by the backend
   * @format date
   */
  date?: string | null;
  severity: Severity;
  deviceRelated: RelatedProbability;
  examProcedureRelated: RelatedProbability;
  actionTaken: AdverseEventActionTaken;
  outcome: AdverseEventOutcome;
  /**
   * Date when the adverse event outcome transitioned from "Ongoing" outcome to any other Outcome
   * @format date
   */
  resolveDate?: string | null;
  /** Was this device deficiency report sent to authorities */
  sentToAuthorities: boolean;
}

export interface AggregatedBloodPressureData {
  /** @format date-time */
  measuredAt?: string;
  avgDay?: BloodPressure;
  avgNight?: BloodPressure;
  minDay?: BloodPressure;
  maxDay?: BloodPressure;
  minNight?: BloodPressure;
  maxNight?: BloodPressure;
}

export type AggregationResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_a1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_b1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_c1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_a2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_b2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_c2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_a3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_b3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_c3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_a1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_b1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_c1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_a2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_b2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_c2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_a3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_b3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_c3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  total_lesions?: number;
};

export type AktiiaMonitorBloodPressureAssignment = AssignmentData & {
  /** Must be set to ```AktiiaMonitorBloodPressureAssignment``` */
  $type?: string;
  deviceSerialNumber: string;
  /** Indicates which side/orientation the patient is wearing the Aktiia/Omron device */
  wearableLocation: WearableLocation;
  /** @format date-time */
  returnAt: string;
  /** @format date-time */
  returnedAt?: string | null;
  /** Predefined return locations for device */
  returnLocation: DeviceReturnLocation;
  /** @format int32 */
  minCompletedMeasurements: number;
  rawMeasurements: BloodPressureData[];
  measurements: AggregatedBloodPressureData[];
  doctorsNote?: string | null;
};

export type AktiiaMonitorBloodPressureAssignmentRequest =
  AssignmentDataRequest & {
    /** Must be set to ```AktiiaMonitorBloodPressureAssignment``` */
    $type?: string;
    deviceSerialNumber: string;
    /** Indicates which side/orientation the patient is wearing the Aktiia/Omron device */
    wearableLocation?: WearableLocation;
    /** @format date-time */
    returnAt: string;
    /** @format int32 */
    minCompletedMeasurements: number;
  };

/** A single alert message */
export interface AlertMessage {
  /** The ID of the Alert */
  alertId?: string;
  /** A message describing the alert state */
  message?: string;
  /** The alert severity (error, warning or notice) */
  severity?: string;
}

/** Allowed timestamp types */
export enum AllowedTimestampType {
  Point = "point",
  Range = "range",
  Any = "any",
}

/** An annotation */
export interface Annotation {
  /** The ID of the annotation */
  id: string;
  /**
   * The ID of the patient
   * @format string
   */
  patientId: string;
  /** Details of a patient that can be rendered in UI */
  patientInformation?: PatientInformation;
  /**
   * The physical artefact ID, this optional ID is used to
   * group different annotations of the same physical artefact
   * into a group. For example, two annotations of the same
   * mole should share the same physical artefact ID.
   */
  physicalArtefactId: string | null;
  /** Indicates what state an annotation is in. Useful both for a UI in filtering / determining what to visualize, but also for ML purposes. */
  acceptState: AcceptState;
  /**
   * The timestamp when the annotation was created
   * @format date-time
   */
  createdAt: string;
  /**
   * The timestamp when the annotation was last modified
   * @format date-time
   */
  updatedAt: string;
  /** A URI to the object being annotated */
  targetUri: string;
  /**
   * Application specific target, can be used by specific applications
   * to add a specific way of targeting annotations when the
   * <cref name="TargetUri" /> is not specific enough. TargetUri is still
   * required.
   */
  applicationSpecificTarget: string | null;
  /** The classification of the annotation */
  classification:
    | MoleClassification
    | PsoriasisClassification
    | OtherClassification
    | BodyPartClassification
    | GarbageClassification
    | null;
  /** The annotation data, for example BoundingBox */
  data:
    | AnnotationData2D
    | AnnotationData3D
    | AnnotationDataRange
    | AnnotationDataNamedTimestamps
    | AnnotationDataLine2D
    | null;
  /** Generic comment, free form. */
  comment: string | null;
  /** Link to a URL which produces a reasonable preview data, for example a smaller thumbnail */
  previewUrl: string | null;
  /** Audit information */
  audit: AuditInformation;
}

export interface AnnotationData {
  $type: string;
}

export type AnnotationData2D = AnnotationData & {
  /** Must be set to ```2d``` */
  $type?: string;
  /** Represents a Rect */
  rect: Rect;
};

export type AnnotationData3D = AnnotationData & {
  /** Must be set to ```3d``` */
  $type?: string;
  /**
   * List of vertices, where each vertex is represented
   * by an array of length 3
   */
  vertices: number[][];
  /** @format double */
  area?: number | null;
};

export type AnnotationDataLine2D = AnnotationData & {
  /** Must be set to ```line2d``` */
  $type?: string;
  line: Line2D;
};

export type AnnotationDataNamedTimestamps = AnnotationData & {
  /** Must be set to ```namedTimestamps``` */
  $type?: string;
  namedTimestamps: Record<string, number | null>;
};

export type AnnotationDataRange = AnnotationData & {
  /** Must be set to ```range``` */
  $type?: string;
  /** Represents a range of values. */
  range: Range;
};

/** Envelope for paginated responses */
export interface AnnotationPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Annotation[];
}

/** States representing the lifecycle of an assessment */
export enum AssessmentState {
  New = "New",
  Cleared = "Cleared",
  ReviewRequested = "ReviewRequested",
  FollowUpRequested = "FollowUpRequested",
  Ignored = "Ignored",
}

export interface AssessmentSummary {
  itemTypeName: string;
  /** @format uuid */
  itemId?: string;
  /** @format uuid */
  itemVersion?: string;
  /** States representing the lifecycle of an assessment */
  assessmentState?: AssessmentState;
  comment?: string | null;
}

/**
 * Assign the patient of the visit to the room the visit is booked to,
 * or assign the patient to another room.
 */
export interface AssignToRoomRequest {
  /** Override the room id. */
  overrideRoomId?: string | null;
}

/** Information about a patient currently assigned to a room. */
export interface AssignedPatient {
  /**
   * The patient currently assigned.
   * @format string
   */
  patientId?: string;
  /**
   * Optional visit which the assignment comes from.
   * @format uuid
   */
  visitId?: string | null;
  /**
   * The time when the assignment was made.
   * @format date-time
   */
  timestamp?: string;
  /** Information about who or what created or modified an item */
  auditRecord?: AuditRecord;
}

/** An assignment with all the information needed to be displayed in the UI */
export interface Assignment {
  /**
   * The ID of the assignment
   * @format uuid
   */
  assignmentId: string;
  /**
   * The patient ID to whom the assignment belongs.
   * @format string
   */
  patientId: string;
  /** Doctor who's responsible for overseeing the assignment */
  assignedTo: string | null;
  /**
   * Date time at which the assignment starts
   * @format date-time
   */
  startAt: string;
  /**
   * Date time at which the assignment ends
   * @format date-time
   */
  finishAt: string;
  /** The data of the assignment */
  data:
    | AktiiaMonitorBloodPressureAssignment
    | OmronMonitorBloodPressureAssignment
    | RefreshConsentAssignment;
  /** ETag of the assignment */
  eTag: string | null;
  /** Audit information */
  audit: AuditInformation;
  allowedActions: AssignmentAction[];
}

/** Indicates what action to take on an assignment */
export enum AssignmentAction {
  Assign = "assign",
  Terminate = "terminate",
  Postpone = "postpone",
  Accept = "accept",
  Progress = "progress",
  Submit = "submit",
  Complete = "complete",
  Close = "close",
}

export interface AssignmentData {
  $type: string;
  /** Indicates what state an assignment is in. */
  state: AssignmentState;
  notifications: NotificationReference[];
}

export interface AssignmentDataRequest {
  $type: string;
}

/** A containing data regarding the device used in an assignment */
export interface AssignmentDeviceInventory {
  /** The real device's "long" serial number */
  serialNumber: string;
  /** The short alias for the device's "long" serial number, that the operator/doctor will type */
  alias: string;
  /**
   * Indicates what's the type of the assignment
   * Clients use this for querying
   */
  assignmentType: AssignmentType;
  /**
   * The assignmentId that this device is maybe currently assigned to. Null if not assigned.
   * @format uuid
   */
  assignmentId: string | null;
  /** ETag of the assignment device inventory item */
  eTag: string | null;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface AssignmentDeviceInventoryPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: AssignmentDeviceInventory[];
}

/** Indicates what's the type of assignment notification */
export enum AssignmentNotificationType {
  DailyAssignmentProgressReminder = "DailyAssignmentProgressReminder",
  StartAssignmentProgressReminder = "StartAssignmentProgressReminder",
  ReturnDeviceReminder = "ReturnDeviceReminder",
}

/** Envelope for paginated responses */
export interface AssignmentPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Assignment[];
}

/** Indicates what state an assignment is in. */
export enum AssignmentState {
  Assigned = "assigned",
  Terminated = "terminated",
  Postponed = "postponed",
  Accepted = "accepted",
  InProgress = "inProgress",
  Submitted = "submitted",
  Completed = "completed",
  Closed = "closed",
}

/**
 * Indicates what's the type of the assignment
 * Clients use this for querying
 */
export enum AssignmentType {
  AktiiaMonitorBloodPressureAssignment = "aktiiaMonitorBloodPressureAssignment",
  OmronMonitorBloodPressureAssignment = "omronMonitorBloodPressureAssignment",
  RefreshConsentAssignment = "refreshConsentAssignment",
}

/** Request to attach a stripe payment method */
export interface AttachPaymentMethodRequest {
  /** Payment method Id */
  paymentMethodId: string;
}

export type AudioRecordingCount = ImmutableScanResultData & {
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  count?: number;
  /**
   * @format int32
   * @min 0
   * @max 60
   */
  duration?: number;
  $type?: string;
};

export type AudioTranscription = ImmutableScanResultData & {
  text?: string;
  anonymized?: string;
  language?: string;
  summary?: string;
  $type?: string;
};

/** Audit information */
export interface AuditInformation {
  /** Information about who or what created or modified an item */
  created?: AuditRecord;
  /** Information about who or what created or modified an item */
  lastModified?: AuditRecord;
}

export interface AuditLogEntry {
  /**
   * The ID of this audit record item, this id is stable and derived from
   * immutable properties of the audit record.
   * @format uuid
   */
  id: string;
  /** The item type of the item for which this audit record was generated. */
  itemType: string;
  /**
   * The timestamp of the event which created the audit record.
   * @format date-time
   */
  timeStamp: string;
  /** The tenant id of the principal which performed the operation. */
  tenantId: string;
  /** The object id of the principal which performed the operation. */
  objectId: string;
  userCategory: UserCategory;
  /**
   * The patient id of the patient which owns the item.
   * @format string
   */
  patientId: string | null;
  operationType: OperationType;
  dataCategory: DataCategory;
  /** Url of the page from which the resource was accessed. */
  referrer: string | null;
}

/** Envelope for paginated responses */
export interface AuditLogEntryPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: AuditLogEntry[];
}

/** Information about who or what created or modified an item */
export interface AuditRecord {
  /** The user or principal */
  userUri: string | null;
  /**
   * When the operation was recorded
   * @format date-time
   */
  timeStamp: string;
  /**
   * The traceId for the operation which
   * created this audit record
   */
  traceId: string;
}

export interface AuditRecordItem {
  userUri?: string;
  /** @format date-time */
  timeStamp?: string;
  traceId?: string | null;
  /** @format uuid */
  appId?: string | null;
  roles?: string[] | null;
  groupIds?: string[] | null;
  ipAddress?: string | null;
  /** @format uuid */
  deviceId?: string | null;
  environmentOverride?: EnvironmentOverride;
}

export interface BankIdSignOptions {
  personalIdentityNumber?: PersonalIdentityNumber;
  userVisibleData?: string;
  userNonVisibleData?: string;
  documentUrl?: string;
  documentHash?: string;
  sameDevice?: boolean;
  successReturnUrl?: string;
  cancelReturnUrl?: string;
  finalizeSignRequestUri?: string;
  /** @format date-time */
  expiresAt?: string;
}

export interface BaseUrlMapping {
  prefix?: string;
  baseUrl?: string;
}

/** Describes a single error in a failed batch operation */
export interface BatchOperationError {
  statusCode: HttpStatusCode;
  /**
   * A message describing the reason for the failure, or "Failed Dependency" in case this
   * operation would have been successful.
   */
  errorMessage?: string | null;
}

/** Error response type returned by Batch operations */
export interface BatchOperationErrorResponse {
  /** A list of results */
  operationResult: BatchOperationError[];
}

export interface BloodPressure {
  /** @format int32 */
  systolic?: number;
  /** @format int32 */
  diastolic?: number;
}

export interface BloodPressureData {
  /** @format date-time */
  measuredAt?: string;
  bloodPressure?: BloodPressure;
}

export type BodyPartClassification = Classification & {
  /** Must be set to ```bodypart``` */
  $type?: string;
  /** Flag determining the preferred visual representation of the same artifact */
  preferredView?: boolean | null;
  /**
   * Estimated size in mm
   * @format double
   */
  size?: number | null;
  /** Size confidence array (4D-array) */
  sizeConfidence?: number[] | null;
  /** Real world coordinates XYZ (3D-array) */
  xyz?: number[] | null;
  /**
   * Confidence of XYZ estimate
   * @format double
   */
  xyzConfidence?: number | null;
  /** Center of the object given by the center of the ellipse */
  center?: number[] | null;
  ellipse?: Ellipse;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesAsymmetry?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesBorders?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesColor?: number | null;
  /** Latent representation of the annotation */
  latentVector?: number[] | null;
  /**
   * Search index of the mole patch
   * @format int32
   */
  searchIndex?: number | null;
};

export interface CallFunction {
  name: string;
  arguments: string;
}

export interface Cart {
  /** @format string */
  owner?: string;
  /**
   * Any valid ISO3166 alpha-2 or alpha-3 code.
   * @format string
   * @example "SE"
   */
  country?: string;
  /**
   * Any valid ISO4217 alpha-3 code.
   * @format string
   * @example "SEK"
   */
  currency?: string;
  entries?: CartEntry[];
  discountCodes?: string[];
  paymentIntentClientSecret?: string | null;
  /** @format double */
  cartTotal?: number;
  /** Audit information */
  audit?: AuditInformation;
}

export interface CartEntry {
  /** @format int32 */
  count?: number;
  /** @format double */
  price?: number;
  product?: Product;
}

export interface CheckinSessionState {
  /**
   * The ID of this session
   * @format uuid
   */
  sessionId: string;
  sessionState: SessionState;
  /** The state of the concierge app */
  conciergeState: string | null;
  /**
   * If a patient has joined
   * @format string
   */
  patientId: string | null;
  /** The state of the patient app */
  patientState: string | null;
  /** Audit information */
  auditInformation: AuditInformation;
  eTag: string | null;
  /** @format date-time */
  expiresAt: string | null;
}

export interface Choice {
  /** @format int32 */
  index: number;
  message: ResponseMessage;
  finish_reason?: string | null;
}

export interface Classification {
  $type: string;
  /**
   * Confidence score
   * @format double
   * @min 0
   * @max 1
   */
  score?: number;
  /** Model responsible for creating annotation */
  modelName?: string | null;
  /**
   * Model version
   * @format int32
   */
  modelVersion?: number | null;
  /** Indicates what state an annotation is in. Useful both for a UI in filtering / determining what to visualize, but also for ML purposes. */
  modelAcceptState?: AcceptState;
}

export interface CleartextEncryptionType {
  $type?: string | null;
}

export interface Config {
  requiredAudience?: string;
}

export interface ConsentData {
  /** @format date-time */
  expiresAt?: string;
  /** @format date-time */
  createdAt?: string;
  documentUris?: string[];
}

/** When to display this consent to the patient */
export enum ConsentDisplayStage {
  AccountCreation = "AccountCreation",
  Booking = "Booking",
  PreVisit = "PreVisit",
  DuringVisit = "DuringVisit",
}

/** Description of a consent */
export interface ConsentMetadata {
  /** Consent Id */
  consentId: string;
  /** Documents to read by language */
  documents: LanguageUri[];
  /** Stage when to show the consent */
  displayStages: ConsentDisplayStage[];
  /** Consent type */
  consentType: ConsentType;
  /**
   * Default expiration of the consent
   * @format date-span
   */
  defaultExpiration: string | null;
  /** Signature type for a consent */
  signatureType: ConsentSignatureType;
  /** If we should ask for consent when patient is at stage (for example, every visit) */
  askConsentEveryTime: boolean;
  /** If true, allows opt out and is not required to perform a scan */
  optional: boolean;
}

/** Describes which ruleset should be applied to evaluate consents */
export enum ConsentRuleset {
  Gdpr = "gdpr",
  ClinicDataSharingAgreement = "clinicDataSharingAgreement",
}

/** A signed consent */
export interface ConsentSignature {
  /**
   * The ID of the patient who signed this consent
   * @format string
   */
  patientId: string;
  /**
   * The ID of the consent
   * @format uuid
   */
  id: string;
  /**
   * When the consent was created, which is the same as
   * the time it was signed.
   * @format date-time
   */
  signedAt: string;
  /**
   * The time when the consent expires.
   * @format date-time
   */
  expiresAt?: string;
  /** Whether the consent has expired or not */
  expired: boolean;
  /** Whether the consent was opted out or not */
  optedOut: boolean;
  /**
   * What type of signature or authorization method
   * was used to sign this consent
   */
  signatureType: string;
  /**
   * The URL of the document which was signed. This Url currently
   * implies which claims the user consented to.
   * @format uri
   */
  documentUri: string;
  /** Audit information */
  audit: AuditInformation;
  /** Information about who or what created or modified an item */
  revocationAuditRecord?: AuditRecord;
  /** Information about who or what created or modified an item */
  exclusionAuditRecord?: AuditRecord;
  /** Information about who or what created or modified an item */
  optOutAuditRecord?: AuditRecord;
  /** This consent requires a counter-signature */
  counterSignatureRequired?: boolean;
  /** Consent Metadata Id */
  consentMetadataId?: string;
  /** Information about who or what created or modified an item */
  counterSignatureAuditRecord?: AuditRecord;
}

/** Base type for consent signature requests */
export interface ConsentSignatureRequest {
  /** Should be set to the discriminator of one of the subtypes of ConsentSignatureRequest */
  $type: string;
}

/** Signature type for a consent */
export enum ConsentSignatureType {
  Self = "self",
  OnBehalf = "onBehalf",
}

/** A summary of a signed consent */
export interface ConsentSummary {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  expiresAt: string;
  expired: boolean;
  optedOut: boolean;
  signatureType: string;
  /** @format uri */
  documentUrl: string;
  counterSignatureRequired: boolean;
  /** ID of the consent */
  consentId: string;
  /** If the consent was revoked */
  revoked?: boolean;
  /**
   * When the consent was revoked
   * @format date-time
   */
  revokedAt?: string | null;
}

/** Envelope for paginated responses */
export interface ConsentSummaryPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: ConsentSummary[];
}

/** Consent type */
export enum ConsentType {
  Gdpr = "Gdpr",
  Study = "Study",
  Other = "Other",
}

export enum ConsentValidityState {
  WithinValidityRange = "withinValidityRange",
  Expired = "expired",
}

export interface ContactDetails {
  addressLines?: string[];
  countryOrRegion?: string;
  zipCode?: string;
  phoneNumbers?: string[];
  email?: string;
}

export interface CopyCodecType {
  $type?: TrackCodecItemKind;
}

export interface CreateAnnotationBatchRequest {
  /**
   * @maxItems 100
   * @minItems 1
   */
  annotationCreateRequests?: CreateAnnotationRequest[];
}

/** An annotation */
export interface CreateAnnotationRequest {
  /**
   * The physical artefact ID, this optional ID is used to
   * group different annotations of the same physical artefact
   * into a group. For example, two annotations of the same
   * mole should share the same physical artefact ID.
   * @example "bb6e09db-8663-42a9-877c-2021bceab4ff"
   */
  physicalArtefactId?: string | null;
  /** Indicates what state an annotation is in. Useful both for a UI in filtering / determining what to visualize, but also for ML purposes. */
  acceptState: AcceptState;
  /**
   * A URI to the object being annotated
   * @example "cur8:recording:{deviceId}:{recordingId}:{trackId}:{frameCounter}"
   */
  targetUri: string;
  /**
   * Application specific target, can be used by specific applications
   * to add a specific way of targeting annotations when the
   * <cref name="TargetUri" /> is not specific enough. TargetUri is still
   * required.
   * @example "rgb_3b/2x3"
   */
  applicationSpecificTarget?: string | null;
  /**
   * Link to a URL which produces a reasonable preview data, for example a smaller thumbnail
   * @example "https://dev.cur8.co/transcoder/img/..."
   */
  previewUrl?: string | null;
  /** Generic comment, free form. */
  comment?: string | null;
  classification?:
    | MoleClassification
    | PsoriasisClassification
    | OtherClassification
    | BodyPartClassification
    | GarbageClassification
    | null;
  data?:
    | AnnotationData2D
    | AnnotationData3D
    | AnnotationDataRange
    | AnnotationDataNamedTimestamps
    | AnnotationDataLine2D
    | null;
}

/** Request to create a new assignment devic inventory item */
export interface CreateAssignmentDeviceInventoryRequest {
  /** The real device's "long" serial number found on the device's box */
  serialNumber: string;
  /**
   * The short alias for the device's "long" serial number, that the operator/doctor will type
   * @minLength 3
   * @maxLength 30
   */
  alias: string;
  /**
   * Indicates what's the type of the assignment
   * Clients use this for querying
   */
  deviceType?: AssignmentType;
}

/** Request to create a new assignment */
export interface CreateAssignmentRequest {
  /**
   * Date time at which the assignment starts
   * @format date-time
   */
  startAt: string;
  /**
   * Date time at which the assignment ends
   * @format date-time
   */
  finishAt: string;
  /**
   * Data of the assignment
   * Here we can specify what kind of assignment it is
   */
  data:
    | AktiiaMonitorBloodPressureAssignmentRequest
    | OmronMonitorBloodPressureAssignmentRequest
    | RefreshConsentAssignmentRequest;
}

export interface CreateAttachmentRequest {
  name?: string;
  storageName?: string;
  contentType?: string;
  encryptionHeader?: EcdhAesGcmEncryptionHeader;
}

export interface CreateAttachmentsRequest {
  attachments?: CreateAttachmentRequest[];
}

/** Request to create a new CapturePaymentDetails notification. */
export interface CreateCapturePaymentDetailsNotificationRequest {
  /**
   * A PatientId to associate with the notification to
   * @format string
   */
  patientId?: string;
  /**
   * Time to send the notification
   * @format date-time
   */
  scheduledTimeStamp?: string;
}

/** Request to create a checkin session */
export interface CreateCheckinSessionRequest {
  /**
   * The checkin session Id will be computed from this seed (and more)
   * Seed: string min 2, max 36
   * @minLength 2
   * @maxLength 36
   */
  seed: string;
}

/** Request to create a new Email notification. */
export interface CreateEmailNotificationRequest {
  /** Destination email to send the notification */
  contacts?: EmailAddress[];
  /** The notification email template to use */
  sendGridTemplateIds: Record<string, string>;
  sender?: EmailAddress;
  /**
   * A PatientId to associate with the notification to
   * @format string
   */
  patientId: string | null;
  /**
   * Time to send the notification
   * @format date-time
   */
  scheduledTimeStamp?: string;
  /** A dictionary of parameters to pass to the template */
  templateParameters?: Record<string, string>;
}

/** Request payload to create a frame index slice */
export interface CreateFrameIndexSliceRequest {
  /**
   * The list of frames in this slice
   * @maxItems 1000
   * @minItems 1
   */
  frames?: FrameOffset[];
  /**
   * If encrypted, the size of the encryption header
   * @format int64
   */
  headerSize?: number;
}

/** Request to create a new FreeText notification. */
export interface CreateFreeTextNotificationRequest {
  /** Destination mobile phone number to send the notification */
  phoneNumber: string;
  /** The notification text to send */
  notificationText: string;
  /** The sender phonenumber or shortcode */
  sender: string | null;
  /**
   * Time to send the notification
   * @format date-time
   */
  scheduledTimeStamp: string | null;
}

/**
 * Create a new immutable scan object from a set of recordings
 * or if the
 */
export interface CreateImmutableScanOrNewVersionRequest {
  /**
   * The primary source uri from which this scan
   * is created, this uri is used to populate time
   * stamps of the scan object.
   *
   * This uri is used to generate the ID.
   */
  primarySourceUri: string;
  /**
   * The source material for this scan, the
   * source uris are used to compute the scanId
   * so care should be taken in how to pick these.
   *
   * All Uris must refer to objects from the same patient.
   */
  sourceUris: string[];
  /**
   * The type of the scan
   * @format string
   */
  scanType: string;
  /**
   * The list of pending results, for known scan types
   * this list is autopopulated, if the scan type is not
   * known this list must be populated with at least
   * one expected result.
   */
  pendingResults: string[];
  /**
   * Timestamp for when the imported device data was recorded.
   * @format date-time
   */
  recordingTimestamp?: string | null;
  /** Mark scan as internal. Internal scans are not member facing. */
  isInternalScan?: boolean;
  /** Specify scan results to re-use from a previous scan version. */
  resultItemReferences?: ImmutableScanResultItemReference[];
}

/** Request to create a journal note item */
export interface CreateJournalNoteRequest {
  /** Note text */
  note: string;
  /**
   * Visit Id
   * @format uuid
   */
  visitId?: string | null;
  /** Indicates what's the type of Journal Note */
  journalNoteType: JournalNoteType;
}

/** A request to create a new measurement */
export interface CreateMeasurementRequest {
  /** The primary source this measurement was computed or extracted from. */
  sourceUri: string;
  /** The application (including version) used to generate this measurement. */
  generator: string | null;
  /**
   * The name of the metric, for example height, weight, hb0
   * @pattern ^[a-z][a-z0-9_-]*[a-z0-9](\.[a-z][a-z0-9_-]*[a-z0-9])*$
   */
  metricName: string;
  /**
   * The start timestamp of the measurement, or the time of
   * the measurement if the measure is a point measurement
   * instead of a range measurement.
   * @format date-time
   */
  timestampStart: string;
  /**
   * (Optional) If the measurement was taken over a time range
   * the end of the time range, must come after Api.Dto.Measurement.Measurement.TimestampStart
   * @format date-time
   */
  timestampEnd?: string | null;
  /**
   * The type including version of this measurement.
   * @format string
   */
  type: string | null;
  /**
   * The measured dimensions
   * @minItems 1
   */
  dimensions: Dimension[];
  /**
   * The visit ID in which the measurement was taken
   * @format uuid
   */
  visitId?: string | null;
}

/** Request to create a new Generic notification. */
export interface CreateNotificationRequest {
  /** Destination mobile phone number to send the notification */
  phoneNumber: string;
  notificationTextId: GenericNotificationText;
  /**
   * The time to send the notification
   * @format date-time
   */
  scheduledTimeStamp?: string | null;
  /** The sender phone number or alpha-numeric ID. When sender is provided the message will be sent through Twilio. */
  sender?: string | null;
  /**
   * The language for the notification
   * @format string
   */
  language?: string | null;
}

export interface CreateOrGetPatientIdentityRequest {
  /** The ID to map to an existing or new patient */
  physicalId?: string;
}

/** Request to create or update an Incident Report item */
export interface CreateOrUpdateIncidentReportRequest {
  /** List of device deficiencies to create / update */
  deviceDeficiencies?: DeviceDeficiency[];
  adverseEventReport?: AdverseEventReport;
}

export interface CreateOrUpdateResultRequest {
  state: ResultState;
  data?:
    | DelayEstimateResultData
    | ECGIntervalsResultData
    | HeartRateResultData
    | HeartRateVariabilityResultData
    | RespiratoryRateResultData
    | PolytecSnrResultData
    | PiezoQualityResultData
    | PttEstimateResultData
    | RsaTiltResultData
    | SiradQualityResultData
    | SmplBodyMeasurementsResultData
    | DetectionResultData
    | AggregationResultData
    | LinkingResultData
    | AudioRecordingCount
    | AudioTranscription
    | MemberSummary
    | ReviewResult
    | null;
  internalData?:
    | SmplInternalData
    | InternalMemberSummary
    | InternalProblemReport
    | InternalReviewResult
    | null;
  dataVersion?: string | null;
}

export interface CreateOrUpdateResultResponse {
  /**
   * A scan object is the result of a set of recordings and
   * some proceessing to make the recordings meaningful.
   *
   * This object represents the combined state of all
   * results for a single processing run. The individual
   * results can be queried separately.
   */
  scan: ImmutableScan;
  /** A partial result of a scan */
  result: ImmutableScanResult;
}

/** Create PadAssessment Request */
export interface CreatePadAssessmentRequest {
  /** States representing the lifecycle of an assessment */
  assessmentState: AssessmentState;
  /** A free-text supplied by an operator */
  comment?: string | null;
  /** Ratios */
  ratios?: PadAssessmentRatios;
  /** Represents regions of interest. */
  regionsOfInterest?: RegionsOfInterest;
}

/** A map of a patient's internal, external and physical ids */
export interface CreatePatientRequest {
  physicalIds?: string[];
  name?: PersonName;
  contactDetails?: ContactDetails;
  /**
   * Date of birth of the patient
   * @format date
   */
  dateOfBirth?: string | null;
  /** The list of group Ids of the patient */
  groupIds?: string[];
  sex?: Sex;
  /**
   * Language preferred by the patient
   * @format string
   */
  preferredLanguage?: string | null;
  /**
   * Preferred country of the patient
   * @format string
   * @example "SE"
   */
  preferredCountry?: string | null;
  /** Ethnicities of the patient */
  ethnicities?: string[] | null;
  /** List of substances the patient is allergic to */
  allergies?: string[] | null;
  pricingModel?: PricingModel;
  /** List of consents the patient has accepted as part of the account creation flow */
  consentSignatures?: PatientCreateConsentSignatureRequest[] | null;
}

export interface CreatePhysicalArtefactFromAnnotationRequest {
  /** @format uuid */
  annotationId?: string | null;
  tracked?: boolean | null;
  /** @format float */
  size?: number | null;
  state?: PhysicalArtefactState;
  type?: PhysicalArtefactType;
  skinLesionClassification?: SkinLesionClassification;
}

export interface CreatePhysicalArtefactRequest {
  tracked?: boolean | null;
  /** @format float */
  size?: number | null;
  state?: PhysicalArtefactState;
  type?: PhysicalArtefactType;
  skinLesionClassification?: SkinLesionClassification;
}

/** Create Pulse Wave Assessment Request */
export interface CreatePulseWaveAssessmentRequest {
  /** States representing the lifecycle of an assessment */
  assessmentState: AssessmentState;
  /** A free-text supplied by an operator */
  comment?: string | null;
  /** Represents the type of Pulse Wave summary. */
  lveti?: PulseWaveAssessmentData;
  /** Represents the type of Pulse Wave summary. */
  pulseWaveVelocity?: PulseWaveAssessmentData;
  /** Represents the type of Pulse Wave summary. */
  handAsymmetry?: PulseWaveAssessmentData;
  /** Represents the type of Pulse Wave summary. */
  footAsymmetry?: PulseWaveAssessmentData;
}

export interface CreateRecordingPhaseRequest {
  id?: string;
  name?: string;
  /** @format int64 */
  startTimeStamp?: number;
  /** @format int64 */
  endTimeStamp?: number;
  metadata?: Record<string, string>;
}

export interface CreateRecordingPhasesRequest {
  phases?: CreateRecordingPhaseRequest[];
}

export interface CreateRecordingRequest {
  /** The ingestion state */
  state?: IngestionState;
  /** @format string */
  patientId?: string | null;
  generator?: string | null;
  /**
   * Helper type to handle our type/version version identifiers
   * which are used by recordings and scans
   * @format string
   */
  recordingType?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  closedAt?: string;
  /** @uniqueItems true */
  tags?: string[];
  metadata?: Record<string, string>;
  encryptionHeader?: EcdhAesGcmEncryptionHeader;
  attachments?: CreateAttachmentRequest[];
  tracks?: CreateTrackRequest[];
  phases?: CreateRecordingPhaseRequest[];
  trackPhases?: CreateRecordingTrackPhaseRequest[];
  inNewStorageAccount?: boolean;
}

export interface CreateRecordingTrackPhaseRequest {
  id?: string;
  name?: string;
  /** @format int32 */
  trackId?: number;
  /** @format int64 */
  startTimeStamp?: number;
  /** @format int64 */
  endTimeStamp?: number;
  /** @format int64 */
  firstFrameCounter?: number;
  /** @format int64 */
  lastFrameCounter?: number;
  metadata?: Record<string, string>;
}

export interface CreateRecordingTrackPhasesRequest {
  trackPhases?: CreateRecordingTrackPhaseRequest[];
}

export interface CreateRoomRequest {
  /** Id of the room */
  roomId: string;
  /** Display name of the room */
  displayName: string | null;
  /**
   * Id of the patient group of the clinic in which the room is present
   * @format uuid
   */
  patientGroupId: string | null;
  /** Site of the room, namely Clinic/Location */
  site: Site;
  supportedVisitTypeIds?: string[] | null;
}

/** Create a short link */
export interface CreateShortLinkRequest {
  /**
   * Optionally specify an Id for the link,
   * the Id will be used as the path of the url,
   * defaults to a GUID.
   * @pattern [a-z0-9-_+]{5,40}
   */
  id?: string | null;
  /**
   * The target of the link
   * @format uri
   */
  targetUrl?: string;
  /** A description of the URL */
  description?: string | null;
  /**
   * A date and time when the link expires, if the
   * link has expired a request against it either
   * results in redirect to the targetUrl of the
   * link with ID expiryLinkId.
   * @format date-time
   */
  expiresOn?: string | null;
  /** A link to redirect to if this link has expired */
  expiryLinkId?: string | null;
}

/**
 * Request to create a visit item for older integration tests that just need a Visit object,
 * These integration tests don't need the full-fledged site, room, slot, booking, and token that are only created by the ChangeFeed processor
 */
export interface CreateTestVisitRequest {
  /**
   * SlotId of the visit
   * @format uuid
   */
  slotId: string;
  /**
   * Room ID of the visit
   * Set to null if it's a no-show
   */
  roomId?: string;
  /** Site ID */
  siteId?: string;
  visitTypeId: string;
  /**
   * Timestamp of when the slot starts
   * @format date-time
   */
  startTime?: string;
  /**
   * Timestamp of when the slot ends
   * @format date-time
   */
  endTime?: string;
  /**
   * Timestamp of when the concierge started the check-in process for the member
   * Set to null if it's a no-show
   * @format date-time
   */
  checkinStartTimestamp?: string | null;
  /**
   * Timestamp of when the concierge ended the check-in process for the member
   * Set to null if it's a no-show
   * @format date-time
   */
  checkinEndTimestamp?: string | null;
}

/** Create Thermal Assessment Request */
export interface CreateThermalAssessmentRequest {
  /** States representing the lifecycle of an assessment */
  assessmentState: AssessmentState;
  /** A free-text supplied by an operator */
  comment?: string | null;
  /** Status representing findings from a thermal assessment */
  status?: ThermalAssessmentStatus;
  /** Represents regions of interest. */
  regionsOfInterest?: RegionsOfInterest;
}

export interface CreateTrackRequest {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  contentType?: FlatbuffersTrackContentType;
  encryptionHeader?: EcdhAesGcmEncryptionHeader;
  codecType?: CopyCodecType | ZstdCodecType | null;
  nodeName?: string | null;
  publisherName?: string | null;
  statistics?: TrackStats;
  trackBlobName?: string;
}

/** Create Visit Summary */
export interface CreateVisitSummaryRequest {
  /**
   * Date of the visit
   * @format date
   */
  visitDate: string;
  /** Summary of the visit */
  summaryText: string;
  /**
   * Follow-up date for next visit
   * @format date
   */
  followUpDate: string | null;
  /**
   * Id of the Visit
   * @format uuid
   */
  visitId?: string | null;
}

/** Request to create Visit Type */
export interface CreateVisitTypeRequest {
  /** Category of the visit type */
  visitTypeCategory: VisitTypeCategory;
  /**
   * Default length of the visit, is used in UI to provide sensible default
   * @format int32
   */
  defaultLengthMinutes: number;
  /** Required consents */
  consents: ConsentMetadata[] | null;
}

export interface DataAnnotationItem {
  id?: string;
  /** @format uuid */
  dataId?: string;
  partitionKey?: string;
  targetUri?: string;
  status?: FrameState;
  /** @format uuid */
  taskId?: string;
  isLocked?: boolean;
  lockedBy?: string | null;
  /** @format date-time */
  lockExpiresAt?: string | null;
  /** @format date-time */
  createdAt?: string;
  itemType?: string;
  /** @format date-time */
  _ts?: string | null;
  _etag?: string | null;
  /** @format int32 */
  ttl?: number;
  createdAuditRecord?: AuditRecordItem;
  lastModifiedAuditRecord?: AuditRecordItem;
  deletedAuditRecord?: AuditRecordItem;
  deleteJobPointer?: string | null;
}

/** Envelope for paginated responses */
export interface DataAnnotationItemPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: DataAnnotationItem[];
}

export enum DataCategory {
  Metadata = "metadata",
  Content = "content",
}

/** A range of DateTime which simplifies querying for date ranges */
export interface DateTimeRange {
  /**
   * Inclusive
   * @format date-time
   */
  start?: string | null;
  /**
   * Exclusive
   * @format date-time
   */
  end?: string | null;
}

export type DelayEstimateResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min -1
   * @max 1
   */
  delayEstimate?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  quality?: number;
};

export type DetectionResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_a1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_b1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_c1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_a2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_b2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_c2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_a3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_b3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  front_c3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_a1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_b1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_c1?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_a2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_b2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_c2?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_a3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_b3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  back_c3?: number;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  total_detections?: number;
};

export interface Device {
  deviceName: DeviceName;
  /** Optional ID of the device, ex.: Cardio P3 (PDM-ID: 100596) */
  id?: string | null;
}

/** Contains aggregated information about containers running on a device */
export interface DeviceContainerAggregate {
  /** Indicates anomalies, such as container overrides, if present */
  status?: string | null;
  /** Contains the common container commit if all is fine */
  commit?: string | null;
}

export interface DeviceContainerConfig {
  /**
   * The configured image. If ```imageOverride``` has been
   * specified it takes precedence.
   */
  image?: string | null;
  /** The configured override image. */
  imageOverride?: string | null;
  /** Whether the container is enabled or disabled on the device. */
  disabled?: boolean;
  /** List of /dev/ devices to expose into the container. */
  devices?: string[];
  /**
   * A dictionary of environment variables to expose to the container
   * the value of an environment variable can be JSON token which will
   * then be serialized to a string before sending it to the device.
   */
  environment?: Record<string, any>;
}

/** Information about a container configured on device */
export interface DeviceContainerResponse {
  name?: string;
}

export interface DeviceDeficiency {
  device: Device;
  /** Description of the device deficiency, free text */
  description: string;
  possibleReason: PossibleReason;
  issueCategory: IssueCategory;
  actionTaken: DeviceDeficiencyActionTaken;
  /** Did the device deficency lead to health risk */
  ledToHealthRisk: boolean;
  /** Was this device deficiency report sent to authorities */
  sentToAuthorities: boolean;
}

export interface DeviceDeficiencyActionTaken {
  action: IncidentReportAction;
  /** What other action was taken due to the device deficiency */
  other?: string | null;
}

export enum DeviceName {
  CardioSystem = "cardioSystem",
  SkinSystem = "skinSystem",
  TissueSystem = "tissueSystem",
  BloodSystem = "bloodSystem",
  CardioLasers = "cardioLasers",
  CardioRadar = "cardioRadar",
  DermaApp = "dermaApp",
  DocUI = "docUI",
  Ecg = "ecg",
  EyePressure = "eyePressure",
  GripStrength = "gripStrength",
  MesiSystem = "mesiSystem",
  Pox = "pox",
  Scale = "scale",
}

/** Contains basic information about a Device */
export interface DeviceResponse {
  /** Id of the Device as per IOT Hub */
  deviceId?: string;
  /** Connected or Disconnected in the IOT Hub */
  connectionState?: string;
  /** Contains aggregated information about containers running on a device */
  containerAggregate?: DeviceContainerAggregate;
  /** Type of the device, e.g. 'cardio', 'skin'. */
  deviceType?: string | null;
  /** Any alert information reported by the device governor */
  alerts?: ModuleAlerts[];
  /** The room id tags assigned to the device */
  roomId?: string | null;
  /** The regulatory region in case this is set */
  regulatoryRegion?: string | null;
  /** An optional maintenance tag indicating that the system is under maintenance */
  maintenanceTag?: string | null;
}

/** Envelope for paginated responses */
export interface DeviceResponsePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: DeviceResponse[];
}

/** Predefined return locations for device */
export enum DeviceReturnLocation {
  Regeringsgatan61BStockholm = "Regeringsgatan 61B, Stockholm",
}

/** A dimension of a measurement */
export interface Dimension {
  /** The name of the dimension */
  name: string;
  /**
   * The value of the dimension
   * @format double
   */
  value: number;
  /** The unit of the dimension */
  unit?: string | null;
}

/** Describes a dimension of a measurement */
export interface DimensionType {
  /** The name of the dimension */
  name?: string;
  /**
   * The unit of this dimension, `null` for
   * unit-less dimensions such as counters
   * @minLength 1
   */
  unit?: string | null;
  /**
   * Optional minimum allowed value (inclusive)
   * @format double
   */
  minValue?: number | null;
  /**
   * Optional maximum allowed value (inclusive)
   * @format double
   */
  maxValue?: number | null;
  /** Whether the dimension is required when creating a measurement */
  required?: boolean;
}

export interface DiscountToken {
  /** The discount token item id */
  id?: string;
  /**
   * The Referrer of the discount token.
   * @format string
   */
  referrer?: string | null;
  /**
   * The external ID of the Redeemer of the discount token.
   * @format string
   */
  redeemerId?: string | null;
  /** The name of the Redeemer of the discount token. */
  redeemerName?: string | null;
  /** Type of discount token */
  discountTokenType?: DiscountTokenType;
  /**
   * The discount amount in percent.
   * @format int32
   */
  discountAmountPercent?: number | null;
  /**
   * The discount amount (optional).
   * @format int32
   */
  discountAmount?: number | null;
  /**
   * The usage limit of the discount token.
   * @format int32
   */
  usageLimit?: number;
  /**
   * The current usage count of the discount token.
   * @format int32
   */
  usageCount?: number;
  /** Whether the discount token is valid for use */
  isValid?: boolean;
  /** Whether the discount token is still valid for use */
  expired?: boolean;
  /** The shareable discount token code that will yield discount. */
  code?: string;
  /** The discount token's human readable description */
  description?: string | null;
  /** Tags to help with queries and frontend logic */
  tags?: string[] | null;
  /** Whether the discount token belongs to a referrer */
  hasReferrer?: boolean;
  /** Whether the discount token has been redeemed by a customer */
  isRedeemed?: boolean;
  /**
   * The date until which the discount token is valid
   * @format date
   */
  validUntil?: string | null;
  /**
   * The country for which the discount token is valid
   * @format string
   * @example "SE"
   */
  country?: string;
  /** ETag */
  eTag: string;
  /** Audit information */
  audit?: AuditInformation;
}

/** Envelope for paginated responses */
export interface DiscountTokenPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: DiscountToken[];
}

/** Request to create/update a new discount token */
export interface DiscountTokenRequest {
  /** External patient Id of the patient who refers the token */
  referrerId: string | null;
  /** Type of discount token */
  discountTokenType: DiscountTokenType;
  /** Choose a specific code for the discount token */
  discountCode: string | null;
  /** A human readable description for the discount token */
  description: string | null;
  /** Tags to help with queries and frontend logic */
  tags: string[] | null;
  /**
   * Choose a specific discount amount for the discount token
   * @format int32
   */
  discountAmount: number | null;
  /**
   * Choose a discount amount percentage for the discount token
   * @format int32
   */
  discountAmountPercent: number | null;
  /**
   * Choose a limit in terms of how many times the discount token can be redeemed
   * @format int32
   */
  usageLimit?: number | null;
  /**
   * Choose a limit in terms of how many times the discount token can be redeemed
   * @format int32
   */
  usageCount?: number | null;
  /**
   * A date limit for which the discount token is valid
   * @format date
   */
  validUntil: string | null;
  /**
   * Country for which the discount token is valid
   * @format string
   * @example "SE"
   */
  country?: string | null;
}

/** Type of discount token */
export enum DiscountTokenType {
  MultiUseDiscount = "multiUseDiscount",
  SingleFullDiscount = "singleFullDiscount",
  SinglePartialDiscount = "singlePartialDiscount",
  VanityDiscount = "vanityDiscount",
}

export type ECGIntervalsResultData = ImmutableScanResultData & {
  $type?: string;
  pq?: IntervalStats;
  qrs?: IntervalStats;
  qtc?: IntervalStats;
};

export interface EcdhAesGcmEncryptionHeader {
  backendKeyId?: string;
  /** @format byte */
  ephemeralPubKeyBase64?: string;
  fileId?: string;
  /** @format byte */
  saltBase64?: string;
}

export interface EcdhAesGcmEncryptionType {
  $type?: string | null;
  backendKeyId?: string | null;
  /** @format byte */
  ephemeralPubKeyBase64?: string | null;
  fileId?: string | null;
  /** @format byte */
  saltBase64?: string | null;
}

export interface Ellipse {
  /** @format double */
  major?: number;
  /** @format double */
  minor?: number;
  /** @format double */
  rotation?: number;
}

export interface EmailAddress {
  email?: string;
  name?: string | null;
}

/** Request payload for ending the checkin process. */
export interface EndCheckinProcessRequest {
  /** Assign the patient to this room instead of the room in the visit. */
  overrideRoomId?: string | null;
  /**
   * Use this checkin end timestamp, defaults to UtcNow.
   * @format date-time
   */
  checkinEndTimestamp?: string | null;
}

export interface EnsureFrontCustomerInGroupsRequest {
  include: Group[];
  exclude: Group[];
}

export interface EnvironmentOverride {
  stageName?: StageName;
  prHash?: string | null;
  machineName?: string;
}

export interface EphemeralTokenResponse {
  token: string;
}

/** Request to update conset of a patient with signature from BankId */
export interface FinalizeConsentRequestBankId {
  /** Signature from BankId after signing consent */
  signature?: string;
}

export interface FlatbuffersTrackContentType {
  $type?: TrackContentTypeItemKind;
  schemaName?: string | null;
  schemaSha256?: string | null;
  binarySchemaBase64?: string | null;
}

/** Frame index for a specific frame in a track */
export interface FrameIndex {
  /** The ID of the device. */
  deviceId: string;
  /** The ID of the recording. */
  recordingId: string;
  /** The ID of the track. */
  trackId: string;
  /**
   * The Url of the track blob.
   * @format uri
   */
  url: string;
  /** Offset of a frame in a track blob. */
  frame: FrameOffset;
  /** A smaller version of Api.Models.Recording.FlatbuffersTrackContentType */
  contentType: SimplifiedTrackContentType;
  /** The codec used to copy frames into the track. */
  codecType: CopyCodecType | ZstdCodecType | null;
  /**
   * The AesKey required to decrypt the frames in this slice.
   * @format byte
   */
  aesKey: string | null;
  /**
   * The size of the encryption header in the underlying storage blob.
   * @format int64
   */
  encryptionHeaderSize: number;
}

/** Offset of a frame in a track blob. */
export interface FrameOffset {
  /**
   * The frame counter of the frame.
   * @format int64
   */
  frameCounter: number;
  /**
   * The timestamp of the frame
   * @format int64
   */
  timestamp: number;
  /**
   * The start byte offset of the frame in the track blob.
   * @format int64
   */
  byteOffsetStart: number;
  /**
   * The end byte offset of the frame in the track blob.
   * @format int64
   */
  byteOffsetEnd: number;
}

export enum FrameState {
  NotStarted = "notStarted",
  InProgress = "inProgress",
  Completed = "completed",
  Skipped = "skipped",
}

export interface FrontCustomer {
  id?: string | null;
  name?: string | null;
  handles?: FrontHandle[] | null;
  groups?: FrontGroup[] | null;
}

export interface FrontGroup {
  id?: string;
  name?: string;
}

export interface FrontHandle {
  source?: string;
  handle?: string;
}

export interface FunctionName {
  name: string;
}

/** GPS Coordinates object, used in the Address object */
export interface GPSCoordinates {
  /**
   * Latitude
   * @format double
   */
  latitude: number;
  /**
   * Longitude
   * @format double
   */
  longitude: number;
}

export type GarbageClassification = Classification & {
  /** Must be set to ```garbage``` */
  $type?: string;
  /** Latent representation of the annotation */
  latentVector?: number[] | null;
  /**
   * Search index of the lesion patch
   * @format int32
   */
  searchIndex?: number | null;
};

/** Api response representing a GDPR export */
export interface GdprExport {
  /**
   * The id of the gdpr export
   * @format uuid
   */
  id: string;
  /** The patient that the export belongs to */
  patientId: string;
  /** The path to the downloadable blob containing the export */
  path: string;
  /** The state of a job */
  jobState?: JobState;
  /**
   * The time when the export was requested and queued
   * @format date-time
   */
  requestedOn: string;
  /**
   * The time the export process was completed
   * @format date-time
   */
  completedOn?: string | null;
}

export enum GenericNotificationText {
  VipBooking = "vipBooking",
  DiscountTokenUsed = "discountTokenUsed",
  DeviceAssignmentCreated = "deviceAssignmentCreated",
  DeviceAssignmentProgress = "deviceAssignmentProgress",
  DeviceAssignmentSubmitted = "deviceAssignmentSubmitted",
  DeviceAssignmentCompleted = "deviceAssignmentCompleted",
  DeviceAssignmentDeviceReturnReminder24HrsBefore = "deviceAssignmentDeviceReturnReminder24hrsBefore",
  DeviceAssignmentDeviceReturnReminder2HrsBefore = "deviceAssignmentDeviceReturnReminder2hrsBefore",
  DeviceAssignmentDeviceReturnReminderAfter = "deviceAssignmentDeviceReturnReminderAfter",
}

export interface GetBackendKeyResponse {
  /** @format byte */
  key?: string;
}

export interface GetEcdhFileKeyRequest {
  backendKeyId?: string;
  /** @format byte */
  fileKey?: string;
  /** @format byte */
  salt?: string;
  fileId?: string;
}

export interface GetEcdhFileKeyResponse {
  /** @format byte */
  aesKey?: string;
  /** @format byte */
  hmacKey?: string;
}

export interface GetIdentityByInternalIdRequest {
  /** The internal ID of the patient */
  internalId: string;
}

export interface GetIdentityByPhysicalIdRequest {
  /** The physical ID of the patient */
  physicalId: string;
}

export enum Group {
  Lead = "lead",
  Invitee = "invitee",
  Paid = "paid",
  Unbooked = "unbooked",
  Booked = "booked",
  Vip = "vip",
}

export type HeartRateResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min 5
   * @max 300
   */
  heartRate?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  quality?: number;
};

export type HeartRateVariabilityResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  sdnn?: number;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  rmssd?: number;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  sdnnRaw?: number;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  rmssdRaw?: number;
  /**
   * @format double
   * @min 0
   * @max 200
   */
  heartRateVariation?: number;
};

export enum HttpStatusCode {
  Continue = "continue",
  SwitchingProtocols = "switchingProtocols",
  Processing = "processing",
  EarlyHints = "earlyHints",
  Ok = "ok",
  Created = "created",
  Accepted = "accepted",
  NonAuthoritativeInformation = "nonAuthoritativeInformation",
  NoContent = "noContent",
  ResetContent = "resetContent",
  PartialContent = "partialContent",
  MultiStatus = "multiStatus",
  AlreadyReported = "alreadyReported",
  ImUsed = "imUsed",
  MultipleChoices = "multipleChoices",
  MovedPermanently = "movedPermanently",
  Found = "found",
  SeeOther = "seeOther",
  NotModified = "notModified",
  UseProxy = "useProxy",
  Unused = "unused",
  RedirectKeepVerb = "redirectKeepVerb",
  PermanentRedirect = "permanentRedirect",
  BadRequest = "badRequest",
  Unauthorized = "unauthorized",
  PaymentRequired = "paymentRequired",
  Forbidden = "forbidden",
  NotFound = "notFound",
  MethodNotAllowed = "methodNotAllowed",
  NotAcceptable = "notAcceptable",
  ProxyAuthenticationRequired = "proxyAuthenticationRequired",
  RequestTimeout = "requestTimeout",
  Conflict = "conflict",
  Gone = "gone",
  LengthRequired = "lengthRequired",
  PreconditionFailed = "preconditionFailed",
  RequestEntityTooLarge = "requestEntityTooLarge",
  RequestUriTooLong = "requestUriTooLong",
  UnsupportedMediaType = "unsupportedMediaType",
  RequestedRangeNotSatisfiable = "requestedRangeNotSatisfiable",
  ExpectationFailed = "expectationFailed",
  MisdirectedRequest = "misdirectedRequest",
  UnprocessableEntity = "unprocessableEntity",
  Locked = "locked",
  FailedDependency = "failedDependency",
  UpgradeRequired = "upgradeRequired",
  PreconditionRequired = "preconditionRequired",
  TooManyRequests = "tooManyRequests",
  RequestHeaderFieldsTooLarge = "requestHeaderFieldsTooLarge",
  UnavailableForLegalReasons = "unavailableForLegalReasons",
  InternalServerError = "internalServerError",
  NotImplemented = "notImplemented",
  BadGateway = "badGateway",
  ServiceUnavailable = "serviceUnavailable",
  GatewayTimeout = "gatewayTimeout",
  HttpVersionNotSupported = "httpVersionNotSupported",
  VariantAlsoNegotiates = "variantAlsoNegotiates",
  InsufficientStorage = "insufficientStorage",
  LoopDetected = "loopDetected",
  NotExtended = "notExtended",
  NetworkAuthenticationRequired = "networkAuthenticationRequired",
}

/** Represents the status of identity verification. */
export enum IdentityVerificationStatus {
  Pending = "pending",
  Verified = "verified",
  Submitted = "submitted",
  Declined = "declined",
}

/** Response containing the identity verification status of the patient */
export interface IdentityVerificationStatusResponse {
  /** Represents the status of identity verification. */
  identityVerificationStatus: IdentityVerificationStatus;
}

/**
 * A scan object is the result of a set of recordings and
 * some proceessing to make the recordings meaningful.
 *
 * This object represents the combined state of all
 * results for a single processing run. The individual
 * results can be queried separately.
 */
export interface ImmutableScan {
  /**
   * The ID of this scan
   * @format uuid
   */
  id: string;
  /**
   * The version of this scan, a scan can have several
   * versions. Only the latest version is returned in
   * a normal list operation.
   * @format uuid
   */
  version: string;
  /**
   * The patient this scan was made of.
   * @format string
   */
  patientId: string;
  /** The patient groups to which the patient of this scan belongs to. */
  patientGroupIds?: string[] | null;
  /** The list of Uris this scan is derived from */
  sourceUris: string[];
  /**
   * The date when this scan was created, which usually coincides with
   * when the processing started for this scan version, this time
   * stamp represents the time when this object was created, _not_
   * when the underlying event happened, for that information
   * refer to the Api.Dto.Scan.ImmutableScan.Timestamp.
   * @format date-time
   */
  versionCreatedAt: string;
  /**
   * The timestamp of the underlying event. As this object refers to
   * the processed result of a set of raw data, data which was collected
   * at one point in time, this value refers to the time when collection
   * event happened.
   *
   * It is by default set to the Api.Dto.Recording.Recording.CreatedAt
   * timestamp of the recording identified by Api.Dto.Scan.CreateImmutableScanOrNewVersionRequest.PrimarySourceUri.
   * @format date-time
   */
  timestamp: string;
  /** The state of a scan */
  state: ScanState;
  /**
   * The type of this scan
   * @format string
   */
  type: string;
  /**
   * The state of all results which are part of this scan
   *
   *
   *
   * Note: Results reused from previous scan versions will be returned as Api.Dto.Scan.ResultState.Complete.
   *
   * See also <seealso cref="P:Api.Dto.Scan.ImmutableScan.ResultReferences" />
   */
  resultStateSummary: Record<string, ResultState>;
  /**
   * Id of the Visit this scan was taken during
   * @format uuid
   */
  visitId?: string | null;
  /**
   * Id of the Journal Note
   * Used to link the scan to a skin assessment
   * If this field is set, the scan is considered to be Reviewed (in the Skin Book flow)
   * @format uuid
   */
  journalNoteId?: string | null;
  /** Mark scan as internal. Internal scans are not member facing. */
  isInternalScan?: boolean;
}

/** Envelope for paginated responses */
export interface ImmutableScanPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: ImmutableScan[];
}

/** A partial result of a scan */
export interface ImmutableScanResult {
  /**
   * The patient
   * @format string
   */
  patientId: string;
  /** The name of the result, it is unique in a scan */
  name: string;
  /**
   * The scan this result belongs to
   * @format uuid
   */
  scanId: string;
  /**
   * The scan version this result belongs to
   * @format uuid
   */
  scanVersion: string;
  /**
   * The type of scan this result belongs to
   * @format string
   */
  scanType: string;
  state: ResultState;
  /** Optional data embedded into the result */
  data?:
    | DelayEstimateResultData
    | ECGIntervalsResultData
    | HeartRateResultData
    | HeartRateVariabilityResultData
    | RespiratoryRateResultData
    | PolytecSnrResultData
    | PiezoQualityResultData
    | PttEstimateResultData
    | RsaTiltResultData
    | SiradQualityResultData
    | SmplBodyMeasurementsResultData
    | DetectionResultData
    | AggregationResultData
    | LinkingResultData
    | AudioRecordingCount
    | AudioTranscription
    | MemberSummary
    | ReviewResult
    | null;
  /** Optional version info embedded into the result */
  dataVersion?: string | null;
  /** Optional internal data embedded into the result */
  internalData?:
    | SmplInternalData
    | InternalMemberSummary
    | InternalProblemReport
    | InternalReviewResult
    | null;
}

export interface ImmutableScanResultData {
  $type: string;
}

export interface ImmutableScanResultInternalData {
  $type: string;
}

/**
 * A reference to a ResultItem from a previous version of the scan.
 *
 * Allows the re-use of unmodified data across scan versions.
 */
export interface ImmutableScanResultItemReference {
  /**
   * The version of the scan that contains the referenced data
   * @format uuid
   */
  scanVersion?: string;
  /** The name of the result item */
  name?: string;
}

/** Envelope for paginated responses */
export interface ImmutableScanResultPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: ImmutableScanResult[];
}

export enum ImmutableScanState {
  Inprogress = "Inprogress",
  Failed = "Failed",
  Available = "Available",
  Finished = "Finished",
}

export interface IncidentReport {
  /**
   * Patient's external ID
   * @format string
   */
  patientId: string;
  /**
   * Visit Id that the incident report belongs to
   * @format uuid
   */
  visitId: string;
  /** Reporter of the incident report */
  reporter?: string | null;
  /** List of device deficiencies */
  deviceDeficiencies: DeviceDeficiency[];
  adverseEventReport?: AdverseEventReport;
  /** Audit information */
  auditInformation?: AuditInformation;
  eTag: string | null;
}

export enum IncidentReportAction {
  Nothing = "nothing",
  Skipped = "skipped",
  Other = "other",
}

/** The ingestion state */
export enum IngestionState {
  New = "New",
  Started = "Started",
  Completed = "Completed",
  Failed = "Failed",
  Ignored = "Ignored",
  PendingConsentVerification = "PendingConsentVerification",
}

/** Request to initiate signing consent with BankId */
export interface InitiateBankIdConsentSignRequest {
  /** Whether BankId app is on same device */
  sameDevice?: boolean;
  /** Url to return to after successfully signing consent */
  successReturnUrl?: string;
  /** Url to return if user clicked cancel during the process */
  cancelReturnUrl?: string;
  /** Full mame including version of the consent document to sign */
  documentUrl?: string;
  /**
   * Timestamp when the consent expires
   * @format date-time
   */
  expiresAt?: string | null;
}

/** Response to initiate signing consent with BankId */
export interface InitiateConsentSignResponse {
  /** URL to redirect to for initiating consent sign process */
  redirectUrl?: string;
}

/** A request to start a Device Stream */
export interface InitiateDeviceStreamRequest {
  /**
   * Optional parameters to send to the device when initiating the stream,
   * the parameters are stream specific
   */
  streamParams?: Record<string, any>;
}

/** The response to an device stream request */
export interface InitiateDeviceStreamResponse {
  /** The device ID */
  deviceId?: string;
  /** The stream ID */
  streamId?: string;
  /**
   * URL the Client to connect to
   * @format uri
   */
  clientWebSocketUrl?: string;
}

export type InternalMemberSummary = ImmutableScanResultInternalData & {
  $type?: string;
  instruction: string;
  prompt: string;
};

export type InternalProblemReport = ImmutableScanResultInternalData & {
  $type?: string;
  category: string;
  feedback: string;
  reporter: string;
  user: string;
};

export type InternalReviewResult = ImmutableScanResultInternalData & {
  $type?: string;
  savedSummary: string;
  /** @format int32 */
  readTime: number;
  /** @format int32 */
  diffCount: number;
  isLiked: boolean | null;
  user: string;
};

/** A (left/right) border of an interval. Includes the value and whether it's open/closed on that border */
export interface IntervalBorder {
  /**
   * The value of the border
   * @format double
   */
  value?: number;
  /** Whether the border value is included (closed interval) or not (open interval) */
  inclusive?: boolean;
}

export interface IntervalStats {
  /**
   * @format double
   * @min 0
   * @max 1
   */
  mean?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  median?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  stddev?: number;
}

export enum IssueCategory {
  PoorPerformance = "poorPerformance",
  Unreliability = "unreliability",
  PoorQuality = "poorQuality",
  PoorDurability = "poorDurability",
  LackOfSafety = "lackOfSafety",
  Identity = "identity",
}

/** Abstract base class for model item dto, subclasses MUST have a public static readonly string field called ItemTypeName */
export interface ItemDto {
  /** @format string */
  patientId: string;
  eTag?: string | null;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface ItemDtoPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: JournalNote[];
}

/** The state of a job */
export enum JobState {
  Pending = "Pending",
  Scheduled = "Scheduled",
  Running = "Running",
  PauseRequested = "PauseRequested",
  Paused = "Paused",
  ResumeRequested = "ResumeRequested",
  Failed = "Failed",
  CancellationRequested = "CancellationRequested",
  Cancelled = "Cancelled",
  EmergencyStopRequested = "EmergencyStopRequested",
  Stopped = "Stopped",
  Complete = "Complete",
}

export type JournalNote = ItemDto & {
  /**
   * Journal item id
   * @format uuid
   */
  journalItemId: string;
  /**
   * VisitId
   * @format uuid
   */
  visitId?: string | null;
  /**
   * The version of this journal note, a journal note can have several
   * versions. Only the latest version is returned in a normal list operation.
   * @format uuid
   */
  version: string;
  /** The content of the journal note */
  note: string;
  /** Indicates what's the type of Journal Note */
  journalNoteType: JournalNoteType;
};

/** Indicates what's the type of Journal Note */
export enum JournalNoteType {
  Derma = "derma",
}

export interface LabellingTask {
  /** @format uuid */
  id: string;
}

/** Envelope for paginated responses */
export interface LabellingTaskPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: LabellingTask[];
}

export enum LabellingTaskType {
  ObjectDetection2D = "objectDetection2D",
}

/** Uri by language */
export interface LanguageUri {
  language?: string;
  /** @format uri */
  uri?: string;
}

export interface Line2D {
  a: Point2D;
  b: Point2D;
}

export type LinkingResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format int32
   * @min 0
   * @max 65535
   */
  total_lesions?: number;
};

/** Create a consent signature using the login token as proof */
export type LoginTokenConsentSignatureRequest = ConsentSignatureRequest & {
  /** Must be set to "login" */
  $type?: string;
};

/** Create a consent signature from a signed and scanned paper consent */
export type ManualConsentSignatureRequest = ConsentSignatureRequest & {
  /** Must be set to "manual" */
  $type?: string;
  /** The name of the patient blob which contains the scanned document */
  patientBlobName?: string;
};

/** Mark visits as NoShow request */
export interface MarkAsNoShowRequest {
  /** A range of DateTime which simplifies querying for date ranges */
  startDateTimeRange?: DateTimeRange;
}

/** A measurement */
export interface Measurement {
  /**
   * The Id of the measurement
   * @format uuid
   */
  id: string;
  /** The primary source this measurement was computed or extracted from. */
  sourceUri: string;
  /** The application (including version) used to generate this measurement. */
  generator: string | null;
  /**
   * The start timestamp of the measurement, or the time of
   * the measurement if the measure is a point measurement
   * instead of a range measurement.
   * @format date-time
   */
  timestampStart: string;
  /**
   * (Optional) If the measurement was taken over a time range
   * the end of the time range, must come after Api.Dto.Measurement.Measurement.TimestampStart
   * @format date-time
   */
  timestampEnd: string | null;
  /**
   * The type including version of this measurement.
   * @format string
   */
  type?: string | null;
  /** The measured dimensions */
  dimensions: Dimension[];
  /** The risk ranges associated with the dimensions of this measurement */
  riskRanges?: RiskRange[];
  /** The name of the metric, for example height, weight, hb0 */
  metricName: string;
  /**
   * The visit ID in which the measurement was taken
   * @format uuid
   */
  visitId?: string | null;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface MeasurementPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Measurement[];
}

/** Describes the type of a measurement */
export interface MeasurementType {
  /**
   * The typename of this type
   * @format string
   */
  type?: string;
  /** Allowed timestamp types */
  allowedTimestampType?: AllowedTimestampType;
  /** Whether the type is visible for patients */
  visibleForPatient?: boolean;
  /**
   * The list of dimensions for this type
   * @minItems 1
   */
  dimensions?: DimensionType[];
  /** The description of this type */
  description?: string | null;
}

/** Envelope for paginated responses */
export interface MeasurementTypePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: MeasurementType[];
}

export type MemberSummary = ImmutableScanResultData & {
  $type?: string;
  transcription?: AudioTranscription;
  results: string;
  summary: string;
};

/** Summary about a single metric */
export interface MetricSummary {
  /** The name of the metric */
  metricName: string;
  /**
   * The approximate number of data points collected
   * @format int64
   */
  count: number;
}

/** A set of Alerts for a module and node */
export interface ModuleAlerts {
  /** The module ID */
  moduleId?: string;
  /** The node ID */
  nodeId?: string;
  /** The set of Alerts */
  alerts?: AlertMessage[];
}

export type MoleClassification = Classification & {
  /** Must be set to ```mole``` */
  $type?: string;
  /** Flag determining the preferred visual representation of the same artifact */
  preferredView?: boolean | null;
  /**
   * Estimated size in mm
   * @format double
   */
  size?: number | null;
  /** Size confidence array (4D-array) */
  sizeConfidence?: number[] | null;
  /** Real world coordinates XYZ (3D-array) */
  xyz?: number[] | null;
  /**
   * Confidence of XYZ estimate
   * @format double
   */
  xyzConfidence?: number | null;
  /** Center of the object given by the center of the ellipse */
  center?: number[] | null;
  ellipse?: Ellipse;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesAsymmetry?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesBorders?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesColor?: number | null;
  /** Latent representation of the annotation */
  latentVector?: number[] | null;
  /**
   * Search index of the mole patch
   * @format int32
   */
  searchIndex?: number | null;
  raised?: boolean | null;
  pigmented?: boolean | null;
  /** RLE compressed binary mask of the lesion patch (encoded in base64) */
  maskEncodedRLE?: string | null;
  /** Shape of the lesion patch */
  maskShape?: number[] | null;
  /** Surface normal world coordinates XYZ (3D-array) */
  surfaceNormalXYZ?: number[] | null;
  /**
   * Angle against surface normal (theta)
   * @format double
   */
  normalAngle?: number | null;
};

/** Request to trigger the NothingSMS flow */
export interface NothingSMSRequest {
  /** @format uuid */
  scanId: string;
  summaryText: NothingSMSVisitSummaryText;
}

export enum NothingSMSVisitSummaryText {
  Nothing = "nothing",
  Dermo = "dermo",
}

/** A Notification object containing data to send an SMS */
export interface Notification {
  /**
   * The ID of the Notification.
   * @format uuid
   */
  notificationId: string;
  /**
   * Scheduled timestamp at which the notification should be sent
   * @format date-time
   */
  scheduledTimeStamp: string;
  /**
   * Notification sent time
   * @format date-time
   */
  notificationSentTime: string | null;
  /** ETag */
  eTag: string | null;
  /** Type of notification */
  type: string | null;
}

/** Envelope for paginated responses */
export interface NotificationPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Notification[];
}

export interface NotificationReference {
  /** @format uuid */
  notificationId?: string;
  /** @format date-time */
  scheduledTimeStamp?: string;
  /** Indicates what's the type of assignment notification */
  notificationType?: AssignmentNotificationType;
}

export type OmronMonitorBloodPressureAssignment = AssignmentData & {
  /** Must be set to ```OmronMonitorBloodPressureAssignment``` */
  $type?: string;
  deviceSerialNumber: string;
  /** Indicates which side/orientation the patient is wearing the Aktiia/Omron device */
  wearableLocation: WearableLocation;
  /** @format date-time */
  returnAt: string;
  /** @format date-time */
  returnedAt?: string | null;
  /** Predefined return locations for device */
  returnLocation: DeviceReturnLocation;
  /** @format int32 */
  minCompletedMeasurements: number;
  rawMeasurements: BloodPressureData[];
  measurements: SimpleBloodPressureData[];
  doctorsNote?: string | null;
};

export type OmronMonitorBloodPressureAssignmentRequest =
  AssignmentDataRequest & {
    /** Must be set to ```OmronMonitorBloodPressureAssignment``` */
    $type?: string;
    deviceSerialNumber: string;
    /** Indicates which side/orientation the patient is wearing the Aktiia/Omron device */
    wearableLocation?: WearableLocation;
    /** @format date-time */
    returnAt: string;
    /** @format int32 */
    minCompletedMeasurements: number;
  };

/** Create a consent signature on behalf of the patient, this uses the callers token as proof. */
export type OnBehalfOfConsentSignatureRequest = ConsentSignatureRequest & {
  /** Must be set to "onbehalfof" */
  $type?: string;
};

/** Create an OpenAI chat request, */
export interface OpenAIChatRequest {
  /**
   * Prompt (input to GPT)
   * @example [{"role":"system","content":"You are a helpful assistant"},{"role":"user","content":"What is the weather in Stockholm?"}]
   */
  messages: OpenAIMessage[];
  /** @example [{"type":"function","function":{"name":"get_weather","description":"Gets the current weather information","parameters":{"type:":"object","properties":{"location":{"type":"string","description":"The location to get weather information for"},"country":{"type":"string","description":"The country of the city"}},"required":["location","country"]}}}] */
  tools?: OpenAITool[] | null;
  /** @example ""auto"" */
  tool_mode?: string | null;
  tool_choice?: OpenAIToolChoice;
  /**
   * @format int32
   * @example 400
   */
  max_tokens?: number | null;
  /**
   * @format float
   * @example 0.2
   */
  temperature?: number | null;
  /** @format float */
  top_p?: number | null;
  /** @format float */
  frequency_penalty?: number | null;
  /** @format float */
  presence_penalty?: number | null;
  stop?: string | null;
  /** @example "gpt-4" */
  model?: string | null;
  /** @example "2023-12-01-preview" */
  apiVersion?: string | null;
}

export interface OpenAIFunction {
  name: string;
  description: string;
  parameters: ParameterSchema;
}

export interface OpenAIMessage {
  role?: string | null;
  content?: string | null;
}

export interface OpenAIResponse {
  id: string;
  object: string;
  /** @format int32 */
  created: number;
  model: string;
  choices: Choice[];
  usage?: Usage;
}

export interface OpenAITool {
  type?: string;
  function: OpenAIFunction;
}

export interface OpenAIToolChoice {
  type: string;
  function: FunctionName;
}

export interface Operation {
  value?: any;
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export enum OperationType {
  Create = "create",
  Update = "update",
  Delete = "delete",
  Read = "read",
}

export interface Order {
  /** @format string */
  owner?: string;
  cart?: Cart;
  status?: OrderStatus;
  /** Audit information */
  audit?: AuditInformation;
}

/** Envelope for paginated responses */
export interface OrderPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Order[];
}

export enum OrderStatus {
  Payment = "payment",
  Open = "open",
  InProgress = "inProgress",
  Fulfilled = "fulfilled",
  Closed = "closed",
  Refunded = "refunded",
}

export type OtherClassification = Classification & {
  /** Must be set to ```other``` */
  $type?: string;
  /** Flag determining the preferred visual representation of the same artifact */
  preferredView?: boolean | null;
  /**
   * Estimated size in mm
   * @format double
   */
  size?: number | null;
  /** Size confidence array (4D-array) */
  sizeConfidence?: number[] | null;
  /** Real world coordinates XYZ (3D-array) */
  xyz?: number[] | null;
  /**
   * Confidence of XYZ estimate
   * @format double
   */
  xyzConfidence?: number | null;
  /** Center of the object given by the center of the ellipse */
  center?: number[] | null;
  ellipse?: Ellipse;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesAsymmetry?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesBorders?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  scoreFeaturesColor?: number | null;
  /** Latent representation of the annotation */
  latentVector?: number[] | null;
  /**
   * Search index of the lesion patch
   * @format int32
   */
  searchIndex?: number | null;
  /** RLE compressed binary mask of the lesion patch (encoded in base64) */
  maskEncodedRLE?: string | null;
  /** Shape of the lesion patch */
  maskShape?: number[] | null;
};

/** PAD Assessment */
export type PadAssessment = AbstractAssessment & {
  /** Concrete name of the class */
  itemTypeName?: string;
  /** Ratios */
  ratios?: PadAssessmentRatios;
  /** Represents regions of interest. */
  regionsOfInterest?: RegionsOfInterest;
};

/** Ratios */
export interface PadAssessmentRatios {
  /**
   * Blood volume fraction T1
   * @format float
   */
  bloodVolumeFractionT1: number;
  /**
   * Oxygenation T1
   * @format float
   */
  oxygenationT1: number;
}

export interface ParameterDetails {
  type: string;
  description: string;
}

export interface ParameterSchema {
  type?: string;
  properties: Record<string, ParameterDetails>;
  required: string[];
}

/** Helper class to create consents as part of patient create flow */
export interface PatientCreateConsentSignatureRequest {
  /**
   * Uri to the consent which was accepted as part of the account create flow.
   * @format uri
   */
  documentUri?: string;
  /**
   * When the consent expires
   * @format date-time
   */
  expiresAt?: string | null;
}

/** A map of a patient's internal, external and physical ids */
export interface PatientDetails {
  /** Set to true if the information has been censored */
  isCensored?: boolean;
  /**
   * The externalId of the patient
   * @format string
   */
  externalId: string;
  /** The list of physical Ids of the patient */
  physicalIds: string[];
  /** The list of group Ids of the patient */
  groupIds: string[];
  name: PersonName;
  contactDetails: ContactDetails;
  consent: ConsentData;
  /**
   * Date of birth of the patient
   * @format date
   */
  dateOfBirth: string | null;
  sex?: Sex;
  preferredUnitSystem: UnitSystem;
  /**
   * Language preferred by the patient
   * @format string
   */
  preferredLanguage: string | null;
  /**
   * Preferred country of the patient
   * @format string
   * @example "SE"
   */
  preferredCountry: string;
  /** Ethnicities of the patient */
  ethnicities: string[] | null;
  /** List of substances the patient is allergic to */
  allergies: string[] | null;
  /** Describes which ruleset should be applied to evaluate consents */
  primaryConsentRuleset?: ConsentRuleset;
  /** Flags associated with the patient */
  flags: PatientFlag[];
  /** Indicates whether the patient has PassKey enabled */
  hasPasskey: boolean;
  /** Indicates whether the patient has a verified identity */
  hasVerifiedIdentity: boolean;
  /** Stripe customer Id of the patient */
  stripeCustomerId: string | null;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface PatientDetailsPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: PatientDetails[];
}

export enum PatientFlag {
  CanBook = "canBook",
  CantBook = "cantBook",
  Vip = "vip",
  TestPatient = "testPatient",
}

export interface PatientGroup {
  /** @format uuid */
  groupId: string;
  groupName: string;
  requiresGDPRConsent?: boolean;
}

/** Envelope for paginated responses */
export interface PatientGroupPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: PatientGroup[];
}

/** A map of a patient's internal, external and physical ids */
export interface PatientIdentity {
  /** The internalId of the patient */
  internalId: string | null;
  /**
   * The externalId of the patient
   * @format string
   */
  externalId: string | null;
  /** The list of physical Ids of the patient */
  physicalIds: string[] | null;
}

/** Details of a patient that can be rendered in UI */
export interface PatientInformation {
  /**
   * The externalId of the patient
   * @format string
   */
  externalId: string;
  /** The name of the patient to render */
  displayName: string | null;
}

/** Summary of measurement collected of a patient */
export interface PatientMeasurementSummary {
  /**
   * The patient
   * @format string
   */
  patientId: string;
  /** List of collected metrics and some information about them */
  metrics: MetricSummary[];
}

/** Envelope for paginated responses */
export interface PatientMeasurementSummaryPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: PatientMeasurementSummary[];
}

export interface PatientPhoneNumberResponse {
  /** Phone Number of the patient obtained from external sources */
  phoneNumber: string | null;
}

/** Represents a DTO summary of a patient denormalized */
export interface PatientSummary {
  /** Gets or sets the display name of the patient. */
  displayName?: string | null;
  /** Represents the sex of a patient. */
  sex?: string | null;
  /**
   * Gets or sets the date of birth of the patient.
   * @format date
   */
  dateOfBirth?: string | null;
}

export interface PersonName {
  firstName?: string;
  lastName?: string;
  displayName?: string | null;
}

export interface PersonalIdentityNumber {
  /** @format int32 */
  year?: number;
  /** @format int32 */
  month?: number;
  /** @format int32 */
  day?: number;
  /** @format int32 */
  birthNumber?: number;
  /** @format int32 */
  checksum?: number;
}

/**
 * The PhysicalArtefact object is a higher level representation of a physical
 * artefact, typically also represented by a collection of annotations with having
 * their physicalArtefactId propery identical to the id property of a PhysicalArtefact.
 */
export interface PhysicalArtefact {
  /**
   * The ID of this PhysicalArtefact
   * @format uuid
   */
  id: string;
  /**
   * The version of this PhysicalArtefact, a PhysicalArtefact can have several
   * versions. Only the latest version is returned in
   * a normal list operation.
   * @format uuid
   */
  version: string;
  /**
   * The (external) patientId of the patient this Physical Artefact relates to
   * @format string
   */
  patientId: string;
  /** The tracked property may be used to denote if a PhysicalArtefact is relevant or not */
  tracked: boolean | null;
  /**
   * PhysicalArtefact size in mm
   * @format float
   */
  size: number | null;
  state: PhysicalArtefactState;
  type: PhysicalArtefactType;
  skinLesionClassification: SkinLesionClassification;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface PhysicalArtefactPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: PhysicalArtefact[];
}

export interface PhysicalArtefactPatientStatistics {
  /** @format int32 */
  count?: number;
}

export enum PhysicalArtefactState {
  None = "none",
  SelfMonitor = "selfMonitor",
  NeedsDermoscope = "needsDermoscope",
  FollowUp4Months = "followUp4Months",
  NeedsFollowUp = "needsFollowUp",
  NeedsTreatment = "needsTreatment",
  NeedsExcision = "needsExcision",
  WaitingForTestResults = "waitingForTestResults",
  NeedsDermatologistReferral = "needsDermatologistReferral",
  Dermoscoped = "dermoscoped",
  ReferralSent = "referralSent",
  Excised = "excised",
  ClosedAsTreated = "closedAsTreated",
  ClosedAsHarmless = "closedAsHarmless",
  ReferralSentExcision = "referralSentExcision",
  ReferralSentDerma = "referralSentDerma",
}

export enum PhysicalArtefactType {
  SkinLesion = "skinLesion",
  Other = "other",
}

export type PiezoQualityResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min 0
   * @max 10
   */
  medianAmplitude?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  medianPulseScore?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  medianOverallScore?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  maxOverallScore?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  medianMLScore?: number | null;
};

/** A collection of data series */
export interface PlottableData {
  /** The data series */
  series?: Record<string, Series>;
  /**
   * The minimum X value of all series
   * @format int64
   */
  minX?: number;
  /**
   * The maximum X value of all series
   * @format int64
   */
  maxX?: number;
  /**
   * The minimum Y value of all series
   * @format double
   */
  minY?: number;
  /**
   * The maximum Y value of all series
   * @format double
   */
  maxY?: number;
}

/** A timeseries point */
export interface Point {
  /**
   * The X value
   * @format int64
   */
  x?: number;
  /**
   * The Y value
   * @format double
   */
  y?: number;
}

export interface Point2D {
  /** @format int32 */
  x: number;
  /** @format int32 */
  y: number;
}

export type PolytecSnrResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min -300
   * @max 300
   */
  snr?: number;
};

export enum PossibleReason {
  DeviceMalfunction = "deviceMalfunction",
  OperationalIssueOrBug = "operationalIssueOrBug",
  PoorInstructions = "poorInstructions",
}

export enum PricingModel {
  V1 = "v1",
  V2 = "v2",
  V3 = "v3",
}

export interface Product {
  /** @format uuid */
  id: string;
  name: string;
  /**
   * Any valid ISO4217 alpha-3 code.
   * @format string
   * @example "SEK"
   */
  currency: string;
  /** @format double */
  price: number;
}

export type PsoriasisClassification = Classification & {
  /** Must be set to ```psoriasis``` */
  $type?: string;
  /**
   * @format int32
   * @min 0
   * @max 4
   */
  redness?: number | null;
  /**
   * @format int32
   * @min 0
   * @max 4
   */
  thickness?: number | null;
  /**
   * @format int32
   * @min 0
   * @max 4
   */
  scaliness?: number | null;
};

export type PttEstimateResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  pttEstimate?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  quality?: number;
};

export interface PullRequestInfo {
  link?: string;
  hash?: string;
  branch?: string;
  project?: string;
  id?: string;
  sourceVersion?: string;
}

export interface PulseScore {
  name?: string;
  /**
   * @format int32
   * @min 0
   * @max 9
   */
  channel?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  score?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  periodicity?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  sharpness?: number;
}

/** Pulse Wave Assessment */
export type PulseWaveAssessment = AbstractAssessment & {
  /** Concrete name of the class */
  itemTypeName?: string;
  /** Represents the type of Pulse Wave summary. */
  lveti?: PulseWaveAssessmentData;
  /** Represents the type of Pulse Wave summary. */
  pulseWaveVelocity?: PulseWaveAssessmentData;
  /** Represents the type of Pulse Wave summary. */
  handAsymmetry?: PulseWaveAssessmentData;
  /** Represents the type of Pulse Wave summary. */
  footAsymmetry?: PulseWaveAssessmentData;
};

/** Represents the type of Pulse Wave summary. */
export interface PulseWaveAssessmentData {
  /**
   * Gets or sets the value of the Pulse Wave summary.
   * @format double
   */
  value?: number;
  /** Represents a range of values. */
  range: Range;
}

/** Represents a range of values. */
export interface Range {
  /**
   * Gets or sets the starting value of the range.
   * @format float
   */
  from: number;
  /**
   * Gets or sets the ending value of the range.
   * @format float
   */
  to: number;
  /** Gets or sets the unit of measurement for the range. */
  unit?: string | null;
}

/** Information about a recording */
export interface Recording {
  /** The Uri of the recording. */
  uri: string;
  /** The ID of the recording. */
  id: string;
  /** The ID of the device which produced the recording. */
  deviceId: string;
  /**
   * The patient ID
   * @format string
   */
  patientId: string | null;
  /** The patient groups to which the patient of this recording belongs to. */
  patientGroupIds: string[];
  /**
   * The Visit Item's ID to which the recording belongs.
   * @format uuid
   */
  visitId?: string | null;
  /** Details of a patient that can be rendered in UI */
  patientInformation?: PatientInformation;
  /** The ingestion state */
  state: IngestionState;
  /** The type of the recording, of the format ```type/version```. */
  recordingType: string;
  /** ID of the generator. */
  generator: string | null;
  /**
   * Time when the recording was created. This time stamp is
   * generated by the device.
   * @format date-time
   */
  createdAt: string;
  /**
   * Time when the recording was stopped. This time stamp is
   * generated by the device.
   * @format date-time
   */
  closedAt: string;
  /**
   * Tags assigned to the recording. Tags can be used to annotate
   * recordings
   */
  tags: string[];
  /** The encryption header of the recording header. */
  encryptionHeader?: CleartextEncryptionType | EcdhAesGcmEncryptionType | null;
  /** Metadata of the recording assigned during recording. */
  metadata: Record<string, string>;
  /** Map of ```attachmentName``` to metadata of the attachment. */
  attachments: Record<string, RecordingAttachment>;
  /** Map of ```trackStorageName``` to metadata about the track. */
  tracks: Record<string, RecordingTrack>;
  /** Bool indicating whether the recording lives in new storage account */
  inNewStorageAccount: boolean;
}

/** An attachment which is part of a recording. */
export interface RecordingAttachment {
  /** The name of the attachment. */
  name: string;
  /**
   * The name of the attachment in the filesystem, this is
   * an internal value of the recording and should not be
   * used.
   */
  storageName: string;
  /** The content-type of the attachment. */
  contentType: string;
}

export interface RecordingAttachmentList {
  deviceId?: string;
  recordingId?: string;
  attachments?: RecordingAttachment[];
}

/** The header of a frame in a track */
export interface RecordingFrameHeader {
  /**
   * The timestamp of the track using the recorder-clock.
   * @format int64
   */
  timestamp: number;
  /**
   * The counter of the frame.
   * @format int64
   */
  frameCounter: number;
}

/** Metadata about a frame in a recording */
export interface RecordingFrameMetadata {
  /** The ID of the device which made the recording. */
  deviceId: string;
  /** The recordingID of the recording this track is part of. */
  recordingId: string;
  /** The track ID of the track this frame is part of. */
  trackId: string;
  /** The fully qualified node/publisher name. */
  nodePub: string;
  /**
   * The name of the node which produced this track.
   *
   * You must compare both Api.Dto.Recording.RecordingTrack.NodeName and Api.Dto.Recording.RecordingTrack.PublisherName
   * to locate the correct track. Use Api.Dto.Recording.RecordingTrack.NodePub for simplicity.
   */
  nodeName: string;
  /**
   * The name of the published in the node which produced this track.
   *
   * You must compare both Api.Dto.Recording.RecordingTrack.NodeName and Api.Dto.Recording.RecordingTrack.PublisherName
   * to locate the correct track. Use Api.Dto.Recording.RecordingTrack.NodePub for simplicity.
   */
  publisherName: string;
  /** The header of a frame in a track */
  frameHeader: RecordingFrameHeader;
  /** The metadata from the payload of the frame */
  payloadMetadata: any;
  /** The Uri of this frame. */
  uri: string;
}

export enum RecordingLocation {
  DeviceUploadStorage = "deviceUploadStorage",
  RecordingStorage = "recordingStorage",
}

/**
 * A phase of a recording. Phases are modelled after chapters.
 *
 * Phases are projected onto tracks during ingestion to form
 * track phases where frame counters are supplemented if omitted
 * during recording.
 *
 * For a quick visualization of phases in an overview the
 * Api.Dto.Recording.RecordingPhase is the recommended data structure,
 * to get exact frame counters for a phase in a track refer to
 * Api.Dto.Recording.RecordingTrackPhase instead.
 */
export interface RecordingPhase {
  /** The URI of this phase. */
  uri: string;
  /** The ID of the phase. The ID is unique among all phases in a recording. */
  id: string;
  /** The name of the phase. The name is not unique and can be used as a descriptive field. */
  name: string;
  /**
   * The start timestamp of the phase, uses the same
   * clock and resolution as the recording.
   * @format int64
   */
  startTimeStamp: number;
  /**
   * The end timestamp of the phase, uses the same
   * clock and resolution as the recording.
   * @format int64
   */
  endTimeStamp: number;
  /** Custom metadata attached to the phase. */
  metadata: Record<string, string>;
}

/** A very small summary of a frame in a track */
export interface RecordingSimpleTrackFrame {
  /**
   * The zero-based index of the frame in the track
   * @format int32
   */
  index: number;
  /**
   * The frame counter of the frame.
   * @format int64
   */
  frameCounter: number;
  /**
   * The timestamp of the frame
   * @format int64
   */
  timestamp: number;
}

/** Envelope for paginated responses */
export interface RecordingSimpleTrackFramePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: RecordingSimpleTrackFrame[];
}

/** Summarized information about a recording used in enumeration APIs */
export interface RecordingSummary {
  /** The Uri of the recording. */
  uri: string;
  /** The ID of the recording. */
  id: string;
  /** The ID of the device which produced the recording. */
  deviceId: string;
  /**
   * The patient ID
   * @format string
   */
  patientId: string | null;
  /** Details of a patient that can be rendered in UI */
  patientInformation?: PatientInformation;
  /** The ingestion state */
  state: IngestionState;
  /** The type of the recording, of the format ```type/version```. */
  recordingType: string;
  /**
   * Time when the recording was created. This time stamp is
   * generated by the device.
   * @format date-time
   */
  createdAt: string;
  /**
   * Time when the recording was stopped. This time stamp is
   * generated by the device.
   * @format date-time
   */
  closedAt: string;
  /**
   * Tags assigned to the recording. Tags can be used to annotate
   * recordings
   */
  tags: string[];
  /** Metadata of the recording assigned during recording. */
  metadata: Record<string, string>;
  /** Whether the recording is encrypted or not. */
  encrypted: boolean;
  /**
   * Number of attachments.
   * @format int32
   */
  attachmentCount: number;
  /**
   * Number of tracks.
   * @format int32
   */
  trackCount: number;
  /**
   * Number of phases.
   * @format int32
   */
  phaseCount: number;
  /**
   * Number of track phases.
   * @format int32
   */
  trackPhaseCount: number;
}

/** Envelope for paginated responses */
export interface RecordingSummaryPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: RecordingSummary[];
}

/** A track in a recording. */
export interface RecordingTrack {
  /** The ID of the track. */
  id: string;
  /** The ID of the device which made the recording. */
  deviceId: string;
  /** The recordingID of the recording this track is part of. */
  recordingId: string;
  /**
   * Time when the track was created. This time is assigned by
   * the device.
   * @format date-time
   */
  createdAt: string;
  contentType?: FlatbuffersTrackContentType;
  /** The encryption header of this track. */
  encryptionHeader?: CleartextEncryptionType | EcdhAesGcmEncryptionType | null;
  /** The codec used to copy frames into the track. */
  codecType?: CopyCodecType | ZstdCodecType | null;
  /**
   * The name of the node which produced this track.
   *
   * You must compare both Api.Dto.Recording.RecordingTrack.NodeName and Api.Dto.Recording.RecordingTrack.PublisherName
   * to locate the correct track. Use Api.Dto.Recording.RecordingTrack.NodePub for simplicity.
   */
  nodeName: string | null;
  /**
   * The name of the published in the node which produced this track.
   *
   * You must compare both Api.Dto.Recording.RecordingTrack.NodeName and Api.Dto.Recording.RecordingTrack.PublisherName
   * to locate the correct track. Use Api.Dto.Recording.RecordingTrack.NodePub for simplicity.
   */
  publisherName: string | null;
  /** The fully qualified node/publisher name. */
  nodePub: string | null;
  statistics: TrackStats;
  /**
   * The length of the track file in bytes.
   * @format int64
   */
  contentLength?: number;
}

export interface RecordingTrackList {
  deviceId: string;
  recordingId: string;
  tracks: RecordingTrack[];
}

/**
 * A phase of a recording projected onto a track.
 *
 * Phases are modelled after chapters, refer to Api.Dto.Recording.RecordingPhase
 */
export interface RecordingTrackPhase {
  /** The URI of this phase. */
  uri: string;
  /** The ID of the phase. The ID is unique among all phases in a recording. */
  id: string;
  /** The name of the phase. The name is not unique and can be used as a descriptive field. */
  name: string;
  /** The TrackId onto which the phase was projected. */
  trackId: string;
  /**
   * The start timestamp of the phase, uses the same
   * clock and resolution as the recording.
   * @format int64
   */
  startTimeStamp: number;
  /**
   * The end timestamp of the phase, uses the same
   * clock and resolution as the recording.
   * @format int64
   */
  endTimeStamp: number;
  /**
   * The first frame counter which belongs to this phase.
   *
   * Phases are projected onto tracks based on timestamp,
   * unless the frame counter is specified during recording
   * by the recorder; therefore the timestamp and framecounter
   * are not guaranteed to match.
   * @format int64
   */
  firstFrameCounter: number;
  /**
   * The last frame counter which belongs to this phase.
   *
   * Phases are projected onto tracks based on timestamp,
   * unless the frame counter is specified during recording
   * by the recorder; therefore the timestamp and framecounter
   * are not guaranteed to match.
   * @format int64
   */
  lastFrameCounter: number;
  /** Custom metadata attached to the phase. */
  metadata: Record<string, string>;
}

/** Represents a Rect */
export interface Rect {
  /**
   * Gets or sets the top coordinate of the box.
   * @format int32
   */
  top: number;
  /**
   * Gets or sets the left coordinate of the box.
   * @format int32
   */
  left: number;
  /**
   * Gets or sets the width of the box.
   * @format int32
   * @min 0
   * @max 2147483647
   */
  width: number;
  /**
   * Gets or sets the height of the box.
   * @format int32
   * @min 0
   * @max 2147483647
   */
  height: number;
}

export type RefreshConsentAssignment = AssignmentData & {
  /** Must be set to ```RefreshConsentAssignment``` */
  $type?: string;
};

export type RefreshConsentAssignmentRequest = AssignmentDataRequest & {
  /** Must be set to ```RefreshConsentAssignment``` */
  type: string;
};

/** Represents regions of interest. */
export interface RegionsOfInterest {
  /** Represents a Rect */
  forearm: Rect;
  /** Represents a Rect */
  hypothenar: Rect;
}

export enum RelatedProbability {
  NotRelated = "notRelated",
  PossiblyRelated = "possiblyRelated",
  ProbablyRelated = "probablyRelated",
  MostLikelyRelated = "mostLikelyRelated",
}

/** Replace visit summary */
export interface ReplaceVisitSummaryRequest {
  /**
   * Date of the visit
   * @format date
   */
  visitDate: string;
  /** Summary of the visit */
  summaryText: string;
  /**
   * Follow-up date for next visit
   * @format date
   */
  followUpDate: string | null;
  /**
   * Id of the Visit
   * @format uuid
   */
  visitId?: string | null;
  /** Weither to send notification that summary was updated */
  sendSMSNotification?: boolean | null;
}

export type ReportBloodPressureProgress = ReportProgressRequest & {
  /** Must be set to ```ReportBloodPressureProgress``` */
  $type?: string;
  bloodPressure: BloodPressure;
};

/** Request to report values for an assignment */
export interface ReportProgressRequest {
  $type: string;
  /** @format date-time */
  timestamp: string;
}

export enum RequestMethod {
  RenderPatientConsent = "renderPatientConsent",
}

export type RespiratoryRateResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min 5
   * @max 300
   */
  respiratoryRate?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  quality?: number;
};

export interface ResponseMessage {
  role: string;
  content?: string | null;
  tool_calls?: Tool[] | null;
}

export enum ResultState {
  Pending = "pending",
  Inprogress = "inprogress",
  Failed = "failed",
  Complete = "complete",
  Ignored = "ignored",
}

export type ReviewResult = ImmutableScanResultData & {
  $type?: string;
  savedSummary: string;
  /** @format int32 */
  readTime: number;
  /** @format int32 */
  diffCount: number;
  isLiked: boolean | null;
};

/** A risk interval, defined by start and end value and risk level */
export interface RiskInterval {
  /** A (left/right) border of an interval. Includes the value and whether it's open/closed on that border */
  start: IntervalBorder;
  /** A (left/right) border of an interval. Includes the value and whether it's open/closed on that border */
  end: IntervalBorder;
  /** The level of risk */
  riskLevel: RiskType;
  /**
   * The label associated with the risk level.
   * Shown in the graphs in the UI.
   */
  riskLabel: RiskLabel;
}

/**
 * The label associated with the risk level.
 * Shown in the graphs in the UI.
 */
export enum RiskLabel {
  Elevated = "elevated",
  Diabetes = "diabetes",
  High = "high",
  Low = "low",
  Mild = "mild",
  Moderate = "moderate",
  Normal = "normal",
  Optimal = "optimal",
  PreDiabetes = "pre-diabetes",
  VeryHigh = "very high",
  VeryLow = "very low",
  Undefined = "undefined",
}

/** A risk range for a dimension of a measurement */
export interface RiskRange {
  /** The name of the dimension this risk range applies to */
  dimensionName: string;
  /**
   * The country for which this risk range is applicable
   * @format string
   * @example "SE"
   */
  country: string;
  /** The level of risk */
  riskLevel: RiskType;
  /** The risk intervals given the patient's attributes (age, sex, etc.) */
  riskIntervals: RiskInterval[];
}

/** The level of risk */
export enum RiskType {
  Unknown = "unknown",
  Optimal = "optimal",
  Normal = "normal",
  Risk = "risk",
  HighRisk = "highRisk",
  ImmediateRisk = "immediateRisk",
}

/** Room in a clinic. Contains Site information, and supported visit types */
export interface Room {
  /** Id of the room */
  id: string;
  /** Display name of the room */
  displayName: string | null;
  /**
   * Id of the patient group of the clinic in which the room is present
   * @format uuid
   */
  patientGroupId: string | null;
  /** Site of the room, namely Clinic/Location */
  site?: Site;
  /** Types of visits that rooms supports. ie Scan, blood pressure checks, maintenance etc */
  supportedVisitTypes?: VisitType[] | null;
  /** Information about a patient currently assigned to a room. */
  assignedPatient?: AssignedPatient;
}

/** Envelope for paginated responses */
export interface RoomPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Room[];
}

export interface RotateBackendKeyResponse {
  keyId?: string;
}

export type RsaTiltResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min -1000
   * @max 1000
   */
  tilt?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  score?: number;
};

/** Scan booked asset parameters */
export interface ScanBookedAsset {
  /** Shareable asset type */
  type: ShareableAssetType;
  /** Scan booked asset parameters */
  parameters: ScanBookedAssetParameters;
  /** The URL of the asset */
  url: string;
}

/** Scan booked asset parameters */
export interface ScanBookedAssetParameters {
  /** The Member's name */
  name: string;
  /** The date of the scan */
  date: string;
  /** Scan type and number (e.g. Baseline Scan) */
  scan: string;
  /** The name of the site */
  siteName: string;
}

/** Scan complete asset */
export interface ScanCompleteAsset {
  /** Shareable asset type */
  type: ShareableAssetType;
  /** Scan complete asset parameters */
  parameters: ScanCompleteAssetParameters;
  /** The URL of the asset */
  url: string;
}

/** Scan complete asset parameters */
export interface ScanCompleteAssetParameters {
  /** The Member's name */
  name: string;
  /** The date of the scan */
  date: string;
  /** Scan type and number (e.g. Baseline Scan) */
  scan: string;
  /** The name of the site */
  siteName: string;
}

/** The state of a scan */
export enum ScanState {
  Inprogress = "inprogress",
  Failed = "failed",
  Available = "available",
  Finished = "finished",
}

export interface SendSignupLinkRequest {
  /**
   * The phone number to send to, if omitted the
   * first available phone number of the patient
   * is used
   */
  phoneNumber?: string | null;
  /**
   * If set to true a message will not be sent
   * this should be used to show a preview to
   * the user requested the link to be sent
   */
  preview?: boolean;
}

export interface SendSignupLinkResponse {
  /** The phone number the message was sent, or it would have been sent to in case of a preview request */
  phoneNumber?: string;
  /** The body which was sent */
  body?: string;
  /** Whether or not the message was sent */
  messageSent?: boolean;
}

/** A series */
export interface Series {
  /** The name of the series */
  name?: string;
  /** The points in this series */
  points?: Point[];
  /**
   * The minimum Y value in the series
   * @format double
   */
  min?: number;
  /**
   * The maximum Y value in the series
   * @format double
   */
  max?: number;
}

export interface ServerReport {
  service?: string;
  /** @format date-time */
  currentTime?: string;
  stageName?: string;
  environmentType?: string;
  stageRegionalName?: string;
  aspNetCoreEnvironment?: string;
  machineName?: string;
  sourceVersion?: string;
  pullRequestInfo?: PullRequestInfo;
}

export enum SessionState {
  Created = "created",
  WaitingForPatient = "waitingForPatient",
  Established = "established",
  Closed = "closed",
}

export interface SetExclusionCriteriaRequest {
  /** Criterias for why the patient was excluded */
  exclusionCriteria: string[];
}

export enum Severity {
  Mild = "mild",
  Moderate = "moderate",
  Severe = "severe",
  LifeThreatening = "lifeThreatening",
}

export enum Sex {
  Male = "male",
  Female = "female",
}

/** Shareable asset type */
export enum ShareableAssetType {
  ScanBooked = "scanBooked",
  ScanComplete = "scanComplete",
}

export interface ShortLink {
  /**
   * The id of the link, the ID is used as the path
   * part of the ShortUrl, i.e. the shortUrl is
   * https://{linkBaseUrl}/{id}
   */
  id: string;
  /**
   * The short url of the link, performing a GET
   * against this link yields either a 302 with
   * Location set to targetUrl or 404 in case
   * of expiry
   * @format uri
   */
  shortUrl: string;
  /**
   * The target of the link
   * @format uri
   */
  targetUrl: string;
  /** A description of the URL */
  description: string | null;
  /**
   * A date and time when the link expires, if the
   * link has expired a request against it either
   * results in redirect to the targetUrl of the
   * link with ID expiryLinkId.
   * @format date-time
   */
  expiresOn: string | null;
  /** A link to redirect to if this link has expired */
  expiryLinkId: string | null;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface ShortLinkPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: ShortLink[];
}

/** A request to sign a consent. */
export interface SignConsentRequest {
  /**
   * A time when the consent should expire, by default extracted from the consent in question.
   * @format date-time
   */
  expiresAt?: string | null;
  /**
   * The consent text to sign.
   * @format uri
   */
  documentUri: string;
  /** ID of the consent to sign */
  consentMetadataId?: string | null;
  /** The signature to use in the sign request. */
  consentSignature:
    | LoginTokenConsentSignatureRequest
    | ManualConsentSignatureRequest
    | OnBehalfOfConsentSignatureRequest;
}

export interface SimpleBloodPressureData {
  /** @format date-time */
  measuredAt?: string;
  day?: BloodPressure;
  night?: BloodPressure;
}

/** A smaller version of Api.Models.Recording.FlatbuffersTrackContentType */
export interface SimplifiedTrackContentType {
  /** The type of schema, always "flatbuffers" for now. */
  schemaType: string;
  /** The name of the schema */
  schemaName: string;
}

/** Frame index for a specific set of frames in a track */
export interface SingleTrackFrameIndexSet {
  /** The ID of the device. */
  deviceId: string;
  /** The ID of the recording. */
  recordingId: string;
  /** The ID of the track. */
  trackId: string;
  /**
   * The Url of the track blob.
   * @format uri
   */
  url: string;
  /** The offsets of frames in this set. */
  frames: FrameOffset[];
  /** A smaller version of Api.Models.Recording.FlatbuffersTrackContentType */
  contentType: SimplifiedTrackContentType;
  /** The codec used to copy frames into the track. */
  codecType: CopyCodecType | ZstdCodecType | null;
  /**
   * The AesKey required to decrypt the frames in this slice.
   * @format byte
   */
  aesKey?: string | null;
  /**
   * The size of the encryption header in the underlying storage blob.
   * @format int64
   */
  encryptionHeaderSize: number;
}

/** Frame index for a specific slice in a track */
export interface SingleTrackFrameIndexSlice {
  /** The ID of the device. */
  deviceId: string;
  /** The ID of the recording. */
  recordingId: string;
  /** The ID of the track. */
  trackId: string;
  /**
   * The Url of the track blob.
   * @format uri
   */
  url: string;
  /** The offsets of all frames in this slice in the file. */
  frames: FrameOffset[];
  /**
   * The first frame counter in this slice.
   * @format int64
   */
  firstFrameCounter: number;
  /**
   * The last frame counter in this slice.
   * @format int64
   */
  lastFrameCounter: number;
  /** A smaller version of Api.Models.Recording.FlatbuffersTrackContentType */
  contentType: SimplifiedTrackContentType;
  /** The codec used to copy frames into the track. */
  codecType: CopyCodecType | ZstdCodecType | null;
  /**
   * The AesKey required to decrypt the frames in this slice.
   * @format byte
   */
  aesKey?: string | null;
  /**
   * The size of the encryption header in the underlying storage blob.
   * @format int64
   */
  encryptionHeaderSize: number;
}

export type SiradQualityResultData = ImmutableScanResultData & {
  $type?: string;
  siradQuality?: PulseScore[];
};

/** Site of the room, namely Clinic/Location */
export interface Site {
  /** Id of the site */
  siteId: string;
  /** Site name */
  siteName: string;
  /** Address object, used in the Site object */
  address: Address;
  /** String representing the TimeZoneId */
  timeZoneId: string;
  /** Consents that are required for patient to sign */
  consents: ConsentMetadata[];
}

export enum SkinAppointmentStatus {
  Completed = "completed",
  NoShow = "noShow",
  Rebooked = "rebooked",
  CouldNotBook = "couldNotBook",
}

export interface SkinBookQueryResult {
  taskGroup: TaskGroup;
  skinBookTrackings: SkinBookTracking[];
}

/** Envelope for paginated responses */
export interface SkinBookQueryResultPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: SkinBookQueryResult[];
}

export enum SkinBookStatus {
  NotAssessed = "notAssessed",
  AssessedAndDermoscoped = "assessedAndDermoscoped",
  NotAssessedAndDermoscoped = "notAssessedAndDermoscoped",
  Assessed = "assessed",
  BookDerma = "bookDerma",
  BookFollowUp = "bookFollowUp",
  Booked = "booked",
  BookExcision = "bookExcision",
  ReferToAtrium = "referToAtrium",
  ReferToDermatologist = "referToDermatologist",
  ReferralSent = "referralSent",
  CouldNotBook = "couldNotBook",
  ReferralSentExcision = "referralSentExcision",
  ReferralSentDerma = "referralSentDerma",
}

export interface SkinBookTracking {
  /** @format string */
  patientId: string;
  patientDisplayName: string;
  patientPhoneNumber: string;
  /** @format uuid */
  scanId: string;
  sourceUris: string[];
  taskGroup: TaskGroup;
  /** @format date-time */
  scanCreatedAt?: string | null;
  skinBookStatus?: SkinBookStatus;
  /** @format date-time */
  appointmentStartTime?: string | null;
  /** @format uuid */
  visitId?: string | null;
  skinAppointmentStatus?: SkinAppointmentStatus;
  /** @format uuid */
  nothingSMSNotificationId?: string | null;
  /** @format date-time */
  nothingSMSNotificationScheduledTimestamp?: string | null;
  eTag?: string | null;
  /** Audit information */
  audit: AuditInformation;
}

export enum SkinLesionClassification {
  Melanoma = "melanoma",
  MelanocyticNevus = "melanocyticNevus",
  BasalCellCarcinoma = "basalCellCarcinoma",
  ActinicKeratosis = "actinicKeratosis",
  BenignKeratosis = "benignKeratosis",
  Dermatofibroma = "dermatofibroma",
  VascularLesion = "vascularLesion",
  SquamousCellCarcinoma = "squamousCellCarcinoma",
  Other = "other",
}

/** A booking SlotV2 */
export interface SlotV2 {
  /**
   * The ID of the Slot.
   * Composite key consisting of SiteId and SlotId
   */
  slotId: string;
  /** Room in a clinic. Contains Site information, and supported visit types */
  room: Room;
  /**
   * Start time of the slot with offset.
   * The timezone of the datetime will be in the timezone of the site
   * @format date-time
   */
  startTime: string;
  /**
   * End time of the slot with offset.
   * The timezone of the datetime will be in the timezone of the site
   * @format date-time
   */
  endTime: string;
  /** The patient ID to whom the slot is booked. */
  patientId: string | null;
  /**
   * The booking token ID to which the slot is booked.
   * @format uuid
   */
  bookingTokenId: string | null;
  /**
   * Whether this slot can be shown in PatientApp or not.
   * A slot that is not open publicly cannot be booked by a member, but can be booked in DoctorUI if there's no patientId set
   * A slot that is open publicly and doens't have a patientId set can be booked in PatientApp or DoctorUI
   * Calculated from PatientId and IsOpenPublicly.
   */
  isOpenPublicly: boolean;
  /**
   * Whether this slot is free to be booked or not.
   * Calculated from PatientId and IsOpenPublicly.
   * IsBooked and IsOpenPublicly are false when true
   */
  isFree: boolean;
  /** The id of the visit type that this slot allows, default = "Scan" */
  visitTypeId: string;
  /** ETag */
  eTag: string;
}

export type SmplBodyMeasurementsResultData = ImmutableScanResultData & {
  $type?: string;
  /**
   * @format double
   * @min 1000
   * @max 2300
   */
  height?: number;
  /**
   * @format double
   * @min 300
   * @max 2000
   */
  thorax?: number;
  /**
   * @format double
   * @min 300
   * @max 2000
   */
  hip?: number;
  /**
   * @format double
   * @min 300
   * @max 2000
   */
  waist?: number;
  /**
   * @format double
   * @min 100
   * @max 500
   */
  calf?: number;
  /**
   * @format double
   * @min 100
   * @max 500
   */
  neck?: number;
  /**
   * @format double
   * @min 300
   * @max 1500
   */
  carotisSinToFemoralisSin?: number;
  /**
   * @format double
   * @min 20
   * @max 200
   */
  carotisSinToJugulum?: number;
  /**
   * @format double
   * @min 300
   * @max 1500
   */
  carotisSinToSymphysis?: number;
  /**
   * @format double
   * @min 20
   * @max 200
   */
  femoralisSinToSymphysis?: number;
  /**
   * @format double
   * @min 300
   * @max 1500
   */
  femoralisSinToJugulum?: number;
  /**
   * @format double
   * @min 200
   * @max 1500
   */
  jugulumToSymphysis?: number;
};

export type SmplInternalData = ImmutableScanResultInternalData & {
  $type?: string;
  scmVersion?: string | null;
  /** @format date-time */
  scmDateTime?: string | null;
  modelFilename?: string | null;
  /** @format float */
  loss?: number | null;
};

/** Enumeration to describe sort order */
export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export enum StageName {
  Local = "local",
  Pr = "pr",
  Dev = "dev",
  Preprod = "preprod",
  Prod = "prod",
}

/** Request payload used to start the checkin process for a visit. */
export interface StartCheckinProcessRequest {
  /**
   * Value to set for the checkin start timestamp, if `null` the current time will be used instead.
   * @format date-time
   */
  checkinStartTimestamp?: string | null;
}

export interface StaticWebAppInsightsConfig {
  connectionString?: string | null;
}

export interface StaticWebConfigFile {
  stageName?: string | null;
  stageType?: string | null;
  apiBaseUrl?: string | null;
  baseUrlMappings?: BaseUrlMapping[] | null;
  msal?: StaticWebMsalConfig;
  appInsights?: StaticWebAppInsightsConfig;
  appConfig?: any;
}

export interface StaticWebMsalAuthConfig {
  clientId?: string | null;
  authority?: string | null;
  redirectUri?: string | null;
  protocolMode?: string | null;
  knownAuthorities?: string[] | null;
}

export interface StaticWebMsalConfig {
  auth?: StaticWebMsalAuthConfig;
  scopes?: StaticWebMsalScopesConfig;
}

export interface StaticWebMsalScopesConfig {
  login?: string[] | null;
  token?: string[] | null;
}

export interface StripeConnectionSecret {
  secret?: string;
}

export interface StripeCustomerPaymentMethod {
  hasPaymentMethod?: boolean;
  card?: StripeCustomerPaymentMethodCardDetails;
}

export interface StripeCustomerPaymentMethodCardDetails {
  brand?: string;
  /** @format int64 */
  exp_month?: number;
  /** @format int64 */
  exp_year?: number;
  fingerprint?: string;
  last4?: string;
}

export interface StripePaymentIntent {
  clientSecret?: string;
}

export enum TaskGroup {
  Derma = "derma",
  Ops = "ops",
  Atrium = "atrium",
  Operator = "operator",
  Cleared = "cleared",
}

/** Thermal Assessment */
export type ThermalAssessment = AbstractAssessment & {
  /** Concrete name of the class */
  itemTypeName?: string;
  /** List of source URIs from which the thermal assessment is derived */
  sourceUris: string[];
  /** Status representing findings from a thermal assessment */
  status?: ThermalAssessmentStatus;
  /** Represents regions of interest. */
  regionsOfInterest?: RegionsOfInterest;
};

/** Status representing findings from a thermal assessment */
export enum ThermalAssessmentStatus {
  Normal = "Normal",
  Abnormal = "Abnormal",
}

export interface Tool {
  function: CallFunction;
  id: string;
  type: string;
}

export enum TrackCodecItemKind {
  None = "none",
  CopyCodec = "copyCodec",
  ZstdCodec = "zstdCodec",
}

export enum TrackContentTypeItemKind {
  None = "none",
  FlatBuffersContentType = "flatBuffersContentType",
}

export interface TrackStats {
  /** @format int64 */
  numSamples?: number;
  /** @format int64 */
  numDroppedSamples?: number;
  /** @format int64 */
  numBytes?: number;
  /** @format int64 */
  firstFrameCounter?: number;
  /** @format int64 */
  lastFrameCounter?: number;
  /** @format int64 */
  firstTimestamp?: number;
  /** @format int64 */
  lastTimestamp?: number;
  /** @format int64 */
  totalPayloadBytes?: number;
}

export enum UnitSystem {
  Metric = "metric",
  Imperial = "imperial",
}

/** Request to update an assignment */
export interface UpdateAssignmentRequest {
  /**
   * Date time at which the assignment starts
   * @format date-time
   */
  startAt?: string | null;
  /** Indicates which side/orientation the patient is wearing the Aktiia/Omron device */
  wearableLocation?: WearableLocation;
  /**
   * Date time at which the assignment ends
   * @format date-time
   */
  finishAt?: string | null;
  /**
   * Date time at which a device should be returned
   * @format date-time
   */
  returnAt?: string | null;
  /**
   * Date time at which the device was returned
   * @format date-time
   */
  returnedAt?: string | null;
  /** Doctor's note after assessing the measurements at the end of the assignment */
  doctorsNote?: string | null;
  /** Indicates what action to take on an assignment */
  action?: AssignmentAction;
}

/** Request to create a checkin session */
export interface UpdateCheckinSessionRequest {
  /** String field to hold state for ConciergeUI */
  conciergeState?: string | null;
  /** String field to hold state for PatientApp */
  patientState?: string | null;
}

export interface UpdatePatientCartEntryRequest {
  /** @format int32 */
  count?: number;
  /** @format uuid */
  productId?: string;
}

export interface UpdatePatientCartRequest {
  entries?: UpdatePatientCartEntryRequest[];
  discountCodes?: string[];
}

/** Request to add and remove Physical IDs and set consent expiration time */
export interface UpdatePatientDetailsRequest {
  /**
   * The list of physical Ids of the patient
   * @example ["cur8:id:legacy:ken","cur8:id:se:pnum:1212121212"]
   */
  physicalIdsToAdd?: string[] | null;
  /**
   * The list of physical Ids of the patient
   * @example ["cur8:id:legacy:ken","cur8:id:ssn:se:1212121212"]
   */
  physicalIdsToRemove?: string[] | null;
  name?: PersonName;
  contactDetails?: ContactDetails;
  /**
   * Date of birth of the patient
   * @format date
   */
  dateOfBirth?: string | null;
  groupIds?: string[] | null;
  sex?: Sex;
  preferredUnitSystem?: UnitSystem;
  /**
   * Language preferred by the patient
   * @format string
   */
  preferredLanguage?: string | null;
  /** Ethnicities of the patient */
  ethnicities?: string[] | null;
  /** List of substances the patient is allergic to */
  allergies?: string[] | null;
  /** Stripe customer Id of the patient */
  stripeCustomerId?: string | null;
  pricingModel?: PricingModel;
}

/** Request to add and remove PatientFlags to a patient */
export interface UpdatePatientFlagsRequest {
  patientFlagsToAdd?: PatientFlag[] | null;
  patientFlagsToRemove?: PatientFlag[] | null;
}

export interface UpdateRecordingLocationRequest {
  location?: RecordingLocation;
}

export interface UpdateRecordingStateRequest {
  /** The ingestion state */
  state?: IngestionState;
}

export interface UpdateRecordingTagsRequest {
  tags?: string[];
}

/** Update a short link */
export interface UpdateShortLinkRequest {
  /**
   * The target of the link
   * @format uri
   */
  targetUrl?: string;
  /** A description of the URL */
  description?: string | null;
  /**
   * A date and time when the link expires, if the
   * link has expired a request against it either
   * results in redirect to the targetUrl of the
   * link with ID expiryLinkId.
   * @format date-time
   */
  expiresOn?: string | null;
  /** A link to redirect to if this link has expired */
  expiryLinkId?: string | null;
}

/** Request to update a visit item */
export interface UpdateVisitRequest {
  /**
   * Timestamp of when the concierge started the check-in process for the member
   * @format date-time
   */
  checkinStartTimestamp?: string | null;
  /**
   * Timestamp of when the concierge ended the check-in process for the member
   * @format date-time
   */
  checkinEndTimestamp?: string | null;
  /**
   *
   *
   *              Room ID in which the Visit happened.
   *              E.g. "B2C_Clinic"
   *              Set to null if it's a no-show
   *
   *
   *
   *              WITHOUT THE SITE PREFIX! :'(
   *
   */
  roomId?: string | null;
}

/** Request to upsert a skin book appointment tracking item */
export interface UpsertSkinBookTrackingRequest {
  /** @format uuid */
  scanId: string;
  status: SkinAppointmentStatus;
  /** @format date-time */
  appointmentStartTime?: string | null;
}

export interface Usage {
  /** @format int32 */
  prompt_tokens?: number | null;
  /** @format int32 */
  completion_tokens?: number | null;
  /** @format int32 */
  total_tokens?: number | null;
}

export interface User {
  /** ObjectId (oid) of the user */
  objectId: string;
  /** Id of user's home tenant */
  tenantId: string;
  /** User's display name */
  displayName: string;
}

export enum UserCategory {
  User = "user",
  Service = "service",
}

/** A user setting value */
export interface UserSetting {
  /** The name of the setting */
  name: string;
  /** The value of the setting */
  value: any;
  /** Audit information */
  audit: AuditInformation;
  eTag: string;
}

export interface Visit {
  /**
   * The ID of this Visit
   * @format uuid
   */
  visitId: string;
  /**
   * Patient's external ID
   * @format string
   */
  patientId: string;
  /** Id of the Site */
  siteId: string;
  /** Id of the slot associated with this visit */
  slotId: string;
  /** A booking SlotV2 */
  slot?: SlotV2;
  /** Room ID of the visit */
  roomId: string;
  /**
   * Timestamp of the slot's start time with offset
   * @format date-time
   */
  startTime: string;
  /**
   * Timestamp of the slot's end time with offset
   * @format date-time
   */
  endTime: string;
  /**
   * Timestamp of when the concierge started the check-in process
   * @format date-time
   */
  checkinStartTimestamp?: string | null;
  /**
   * Timestamp of when the concierge ended the check-in process
   * @format date-time
   */
  checkinEndTimestamp?: string | null;
  /** Immutable Scans performed during the visit */
  immutableScansPerformed?: Record<string, VisitScanResult>;
  /**
   * Indicates the status of a Visit
   * In a regular flow, a visit will transition from Scheduled -> CheckedIn -> Ongoing -> Completed
   * A Scheduled visit can transition to NoShow or Cancelled
   * A Completed visit can be reprocessed, making it transition to Ongoing -> Completed
   */
  status?: VisitStatus;
  /** Denormalized Assessment Summaries */
  assessmentSummaries?: AssessmentSummary[] | null;
  /** Audit information */
  auditInformation: AuditInformation;
  eTag: string | null;
  consents?: ConsentMetadata[];
}

/** Envelope for paginated responses */
export interface VisitPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Visit[];
}

export interface VisitScanResult {
  /**
   * Scan ID
   * @format uuid
   */
  scanId: string;
  resultState: ImmutableScanState;
}

/**
 * Indicates the status of a Visit
 * In a regular flow, a visit will transition from Scheduled -> CheckedIn -> Ongoing -> Completed
 * A Scheduled visit can transition to NoShow or Cancelled
 * A Completed visit can be reprocessed, making it transition to Ongoing -> Completed
 */
export enum VisitStatus {
  Scheduled = "Scheduled",
  CheckedIn = "CheckedIn",
  Ongoing = "Ongoing",
  Completed = "Completed",
  NoShow = "NoShow",
  Cancelled = "Cancelled",
}

/** Visit summary */
export interface VisitSummary {
  /**
   * Id of visit summary
   * @format uuid
   */
  id: string;
  /**
   * Id of the visited patient
   * @format string
   */
  patientId: string;
  /**
   * Date of the visit
   * @format date
   */
  visitDate: string;
  /** Summary of the visit */
  summaryText: string;
  /**
   * Follow-up date for next visit
   * @format date
   */
  followUpDate: string | null;
  /**
   * Id of the Visit
   * @format uuid
   */
  visitId: string | null;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface VisitSummaryPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: VisitSummary[];
}

/** A type of a visit, ie scan, blood pressue check, maintenance etc. */
export interface VisitType {
  visitTypeId: string;
  /** @format int32 */
  defaultLengthMinutes: number;
  consents: ConsentMetadata[];
}

/** Category of the visit type */
export enum VisitTypeCategory {
  Scan = "Scan",
  ResearchScan = "ResearchScan",
  Dermoscope = "Dermoscope",
  TwentyFourHourBloodPressureCheck = "TwentyFourHourBloodPressureCheck",
  Maintenance = "Maintenance",
}

/** Indicates which side/orientation the patient is wearing the Aktiia/Omron device */
export enum WearableLocation {
  LeftWrist = "leftWrist",
  RightWrist = "rightWrist",
  UpperLeftArm = "upperLeftArm",
  UpperRightArm = "upperRightArm",
}

export interface ZstdCodecType {
  $type?: TrackCodecItemKind;
}

export interface AnnotationListByPatientParams {
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Sort order, sorts by CreatedAt property. Only applies if minSize is not set. */
  order?: SortOrder;
  /** Limit the results to annotations for the specified physical artefact ID */
  physicalArtefactId?: string;
  /** Limit results to specified AcceptState */
  acceptState?: AcceptState;
  /** Filter URI to the object being annotated using STARTSWITH match */
  targetUri?: string;
  /** Filter by the type of classification */
  classificationType?: string;
  /** Filter by the type of the annotation data */
  dataType?: string;
  /** Filter by application specific target using STARTSWITH */
  applicationSpecificTarget?: string;
  /**
   * Filter by minimum size (mm). Always orders by descending size.
   * @format int32
   */
  minSize?: number;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The patient of the annotation
   * @format string
   */
  patientId: string;
}

export interface AnnotationCountPhysicalArtefactsByPatientParams {
  /** Limit results to specified AcceptState */
  acceptState?: AcceptState;
  /** Limit results to specified applicationSpecificTarget (STARTSWITH match) */
  applicationSpecificTarget?: string;
  /**
   * The patient identity
   * @format string
   */
  patientId: string;
}

export interface AnnotationListParams {
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Sort order, sorts by CreatedAt property. Only applies if minSize is not set. */
  order?: SortOrder;
  /** Limit results to specified AcceptState */
  acceptState?: AcceptState;
  /** Filter URI to the object being annotated using STARTSWITH match */
  targetUri?: string;
  /** Filter by the type of classification */
  classificationType?: string;
  /** Filter by the type of the annotation data */
  dataType?: string;
  /** A continuation token */
  continuationToken?: string;
  /** Filter by application specific target using STARTSWITH match */
  applicationSpecificTarget?: string;
  /**
   * Filter by minimum size (mm). Always orders by descending size.
   * @format int32
   */
  minSize?: number;
}

export interface AssessmentListVersionsParams {
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * The patient to whom the assessment item belongs
   * @format string
   */
  patientId: string;
  /**
   * The assessment id
   * @format uuid
   */
  assessmentId: string;
}

export interface AssessmentGetsParams {
  /**
   * Filter results by external patient id
   * @format string
   */
  patientId?: string;
  /** Filter results by Latest Version only */
  isLatestVersion?: boolean;
  /**
   * Inclusive
   * @format date-time
   */
  "createdAt.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "createdAt.end"?: string;
  /** Sort the assessments by startAt timestamp */
  order?: SortOrder;
  /** Filter by AssessmentStates */
  assessmentStates?: AssessmentState[];
  /** Filter by AssessmentTypes */
  assessmentTypes?: string[];
  /** Filter by site id */
  siteId?: string;
  /** Filter by room id */
  roomId?: string;
  /**
   * Filter by visit id
   * @format uuid
   */
  visitId?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface AssignmentGetsParams {
  /**
   * Filter results by external patient id
   * @format string
   */
  patientId?: string;
  /**
   * Inclusive
   * @format date-time
   */
  "startAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "startAtRange.end"?: string;
  /**
   * Inclusive
   * @format date-time
   */
  "finishAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "finishAtRange.end"?: string;
  /** Sort the assignments by startAt timestamp */
  order?: SortOrder;
  /** Filter by AssignmentStates */
  assignmentStates?: AssignmentState[];
  /** Filter by Assignment data type */
  dataType?: AssignmentType;
  /** Filter by Device Assignment Serial Number */
  deviceSerialNumber?: string;
  /** Filter results to the user who is overseeing the assignment */
  assignedTo?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface AssignmentGetPatientsParams {
  /** @format string */
  patientId: string;
  /**
   * Inclusive
   * @format date-time
   */
  "startAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "startAtRange.end"?: string;
  /**
   * Inclusive
   * @format date-time
   */
  "finishAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "finishAtRange.end"?: string;
  /** Sort the assignments by startAt timestamp */
  order?: SortOrder;
  /** Filter by AssignmentStates */
  assignmentStates?: AssignmentState[];
  /** Filter by Assignment data type */
  dataType?: AssignmentType;
  /** Filter by Device Assignment Serial Number */
  deviceSerialNumber?: string;
  /** Filter results to the user who is overseeing the assignment */
  assignedTo?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

/** Request to report values for an assignment */
export type AssignmentReportProgressPayload = ReportBloodPressureProgress;

export interface AssignmentDeviceInventoryQueryItemsParams {
  /** Filter results by device's serial number */
  serialNumber?: string;
  /** Filter results by alias */
  alias?: string;
  /** Filter results by whether the device has an assignment id associated to it or not */
  inUse?: boolean;
  /** Filter by AssignmentType */
  assignmentType?: AssignmentType;
  /**
   * Filter results by a particular assignment id
   * @format uuid
   */
  assignmentId?: string;
  /** Filter results to the user who is overseeing the assignment */
  assignedTo?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface AuditLogQueryParams {
  /**
   * Page size, the number of results may be less than
   * specified in the request, it might even be zero.
   * @format int32
   * @min 1
   * @max 1000
   * @default 100
   */
  pageSize?: number;
  /**
   * Filter by external patient Id (eg: ```P0kfgr7mndvu3z```)
   * @format string
   */
  patientId?: string;
  /** Filter by user URI (eg: ```cur8:user:tenantId:objectId```) */
  userUri?: string;
  /** Operation types to filter by */
  operationTypes?: OperationType[];
  /** Filter by user category (e.g. ```User``` or ```ServicePrincipal```) */
  userCategory?: UserCategory;
  /**
   * ```asc``` or ```desc``` to order by
   *             ```TimeStamp```
   */
  order?: SortOrder;
  /**
   * Inclusive
   * @format date-time
   */
  "timeStampRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "timeStampRange.end"?: string;
  /** The continuation token */
  continuationToken?: string;
}

export interface BillingGetPatientOrdersParams {
  /** @format int32 */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
  /** @format string */
  patientId: string;
}

export interface BillingStripeCompleteCheckoutParams {
  payment_intent_client_secret?: string;
  payment_intent?: string;
  redirect_status?: string;
  /** @format string */
  patientId: string;
}

export interface DetectedMarkingsGetCountParams {
  /** @format string */
  patientId?: string;
  /** @format uuid */
  scanId?: string;
  /** @format uuid */
  scanVersion?: string;
}

export interface DeviceGetsParams {
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
  /** @default false */
  onlyConnected?: boolean;
}

export interface DiscountTokenListsParams {
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Limit results to a specific discount token code */
  discountCode?: string;
  /** Limit results to a referrer id (external id) */
  referrerId?: string;
  /** Limit results to a redeemer id (external id) */
  redeemerId?: string;
  /** Boolean representing whether the discount token has a redeemer */
  hasRedeemer?: boolean;
  /** Boolean times the discount token has been used */
  isValid?: boolean;
  /** Limit results to a single type of discount token */
  discountTokenType?: DiscountTokenType;
  /** A continuation token */
  continuationToken?: string;
}

export interface DiscountTokenQueryPatientsParams {
  /** A continuation token */
  continuationToken?: string;
  /** @format string */
  patientId: string;
}

export interface HealthGetParams {
  "api-version"?: string;
}

export interface HealthGet2Params {
  "api-version"?: string;
}

export interface HealthGetAuthRequiredParams {
  "api-version"?: string;
}

export interface ImmutableScanListScansByPatientParams {
  /**
   * Filter by scan type (eg: ```cardio/4```), if the query is a
   * complete scan type (```type/version```) then it performs
   * an exact match, otherwise it performs a prefix match.
   */
  scanType?: string;
  /** The state of the scans */
  state?: ScanState;
  /** Only include scans with this sourceUri */
  sourceUri?: string;
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Enumeration to describe sort order */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The patient ID
   * @format string
   */
  patientId: string;
}

export interface ImmutableScanDeleteScanParams {
  performDeletion?: boolean;
  /** @format string */
  patientId: string;
  /** @format uuid */
  scanId: string;
}

export interface ImmutableScanListScanVersionsParams {
  /**
   * pageSize
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** results are ordered by when the result was created */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The patient ID
   * @format string
   */
  patientId: string;
  /**
   * The ID of the scan
   * @format uuid
   */
  scanId: string;
}

export interface ImmutableScanListResultsInScanParams {
  state?: ResultState;
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
  /** @format string */
  patientId: string;
  /** @format uuid */
  scanId: string;
  /** @format uuid */
  scanVersion: string;
}

export interface ImmutableScanQueryResultsAcrossAllScansAndVersionsParams {
  /** The name of the result to query */
  resultName?: string;
  /** The state of the result */
  state?: ResultState;
  /**
   * Filter by scan type (eg: ```cardio/4```), if the query is a
   * complete scan type (```type/version```) then it performs
   * an exact match, otherwise it performs a prefix match.
   */
  scanType?: string;
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
}

export interface ImmutableScanQueryAllScanVersionsParams {
  /**
   * Filter by scan type (eg: ```cardio/4```), if the query is a
   * complete scan type (```type/version```) then it performs
   * an exact match, otherwise it performs a prefix match.
   */
  scanType?: string;
  /** Limit to scans with this state */
  state?: ScanState;
  sourceUri?: string;
  /**
   * Only include the latest scan version
   * @default true
   */
  latestOnly?: boolean;
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Enumeration to describe sort order */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
}

export interface IncidentReportQueryParams {
  /**
   * Inclusive
   * @format date-time
   */
  "createdAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "createdAtRange.end"?: string;
  /** Sort the incident reports by the createdAt timestamp */
  order?: SortOrder;
  /**
   * Filter by PatientId
   * @format string
   */
  patientId?: string;
  /**
   * Filter by VisitId
   * @format uuid
   */
  visitId?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface JournalQuerysParams {
  /**
   * Inclusive
   * @format date-time
   */
  "createdAtTimestampRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "createdAtTimestampRange.end"?: string;
  /** Sort the journal by the created at  timestamp */
  order?: SortOrder;
  /**
   * Limit results to latest version of a journal item only
   * @default true
   */
  latestOnly?: boolean;
  /** Limit results to Journal Note of a specific type */
  journalNoteType?: JournalNoteType;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * The patient who journaled
   * @format string
   */
  patientId: string;
}

export type LabellingTaskCreateTaskWithDataPayload = DataAnnotationItem[];

export interface LabellingTaskCreateTaskWithDataParams {
  /** Type of the task to be created */
  taskType: LabellingTaskType;
}

export type LabellingTaskReplaceTaskDataPayload = DataAnnotationItem[];

export interface LabellingTaskGetTaskDataParams {
  /** @format int32 */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
  /**
   * Id of the task
   * @format uuid
   */
  taskId: string;
}

export type LabellingTaskAddDataToTaskPayload = DataAnnotationItem[];

export interface LabellingTaskRecordingPrepRequestParams {
  deviceId?: string;
  recordingId?: string;
  recordingType?: string;
  /** @format uuid */
  taskId: string;
}

export interface LabellingTaskListsParams {
  /** Sort order to sort by creation date (default: Desc) */
  order?: SortOrder;
  /**
   * Page size (default: 50, max: 100)
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
}

export interface LabellingTaskUpdateFrameStatusParams {
  /** The new status for the frame. */
  newStatus?: FrameState;
  /**
   * The taskId associated with the data annotation item.
   * @format uuid
   */
  taskId: string;
  /**
   * The dataId of the data annotation item to update.
   * @format uuid
   */
  dataId: string;
}

export interface LabellingTaskLockItemParams {
  labellerId?: string;
  /** @format uuid */
  taskId: string;
  /** @format uuid */
  dataId: string;
}

export interface LabellingTaskUnlockItemParams {
  labellerId?: string;
  /** @format uuid */
  taskId: string;
  /** @format uuid */
  dataId: string;
}

export interface LinkShortenerQueryLinksParams {
  /**
   * Filter (exact match) by targetUrl
   * @format uri
   */
  targetUrl?: string;
  /** Only show links with this exact expiryLinkId */
  expiryLinkId?: string;
  /**
   * The number of links to return in a page
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Order in descending or ascending order (by createdAt) */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
}

export interface MeasurementQueryParams {
  /**
   * The name of the metric
   * @pattern ^[a-z][a-z0-9_-]*[a-z0-9](\.[a-z][a-z0-9_-]*[a-z0-9])*$
   */
  metricName?: string;
  /** The type prefix of the measurement. */
  typePrefix?: string;
  /** Limit the results to measurements computed from this source */
  sourceUri?: string;
  /**
   * Limit the results to measurements taken in a specific visit
   * @format uuid
   */
  visitId?: string;
  /**
   * Limit the results to measurements taken after or at this timestamp
   * @format date-time
   */
  timestampStart?: string;
  /**
   * Limit the results to measurements taken before this timestamp
   * @format date-time
   */
  timestampEnd?: string;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The patient ID
   * @format string
   */
  patientId: string;
}

export interface MeasurementQuerySummariesParams {
  /**
   * If supplied, only return patients with at least one such measurement
   * @pattern ^[a-z][a-z0-9_-]*[a-z0-9](\.[a-z][a-z0-9_-]*[a-z0-9])*$
   */
  metricName?: string;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
}

export interface NotificationListsParams {
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Sort order, sorts by ScheduledTimeStamp property */
  order?: SortOrder;
  /**
   * Limit the results to Notifications with scheduled time equal or after
   * @format date-time
   */
  notificationStartTime?: string;
  /**
   * Limit the results to Notifications with schedule time equal or before
   * @format date-time
   */
  notificationEndTime?: string;
  /**
   * Limit the results to Notifications belonging to a Slot
   * @format uuid
   */
  slotId?: string;
  /** Boolean representing whether the notification has been sent */
  isNotificationSent?: boolean;
  /** A continuation token */
  continuationToken?: string;
}

export interface PatientConsentQueryParams {
  /**
   * Inclusive
   * @format date-time
   */
  "signedAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "signedAtRange.end"?: string;
  /**
   * Inclusive
   * @format date-time
   */
  "expiresAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "expiresAtRange.end"?: string;
  /** Sort the consents by expiresAt timestamp */
  order?: SortOrder;
  /** Filter by validity */
  validityState?: ConsentValidityState;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * The patient
   * @format string
   */
  patientId: string;
}

export interface PatientConsentRenderParams {
  /**
   * Consent document to render
   * @format uri
   */
  documentUri: string;
  /** Short-lived token obtained from GetEphemeralToken API */
  token: string;
  /**
   * The patient
   * @format string
   */
  patientId: string;
}

export interface PatientDetailsSearchParams {
  /** Some search text */
  text?: string;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
}

export interface PatientDetailsDeletePatientParams {
  /**
   * Whether to perform the deletion.
   * If not set to true, this API will dry-run.
   */
  performDeletion?: boolean;
  /**
   * The patient identity to delete
   * @format string
   */
  patientId: string;
}

export interface PatientDetailsListPatientsParams {
  /**
   * Include patients with expired consent (requires the internal role `Patient.ExpiredConsentAccess`)
   * @default false
   */
  includeWithExpiredConsent?: boolean;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** A continuation token */
  continuationToken?: string;
}

export interface PatientDetailsGetEphemeralTokenParams {
  /** The API method that the client intends to call with the token */
  requestMethod: RequestMethod;
  /**
   * The patient ID
   * @format string
   */
  patientId: string;
}

export interface PhysicalArtefactListsForPatientParams {
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Enumeration to describe sort order */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The patient ID
   * @format string
   */
  patientId: string;
}

export interface PhysicalArtefactListVersionsParams {
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /** Enumeration to describe sort order */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The patient ID
   * @format string
   */
  patientId: string;
  /**
   * The physicalArtefactID
   * @format uuid
   */
  physicalArtefactId: string;
}

export interface RecordingDeleteParams {
  /**
   * Whether to perform the deletion.
   * If not set to true, this API will dry-run.
   */
  performDeletion?: boolean;
  /** The device ID */
  deviceId: string;
  /** The recording ID */
  recordingId: string;
}

export interface RecordingListParams {
  /** Filter by device Id prefix (eg: ```cardi```) */
  deviceId?: string;
  /**
   * Filter by external patient Id (eg: ```P0kfgr7mndvu3z```)
   * @format string
   */
  patientId?: string;
  /**
   * Filter by recording type (eg: ```cardio/4```), if the query is a
   * complete recording type (```type/version```) then it performs
   * an exact match, otherwise it performs a prefix match.
   */
  recordingType?: string;
  /** Filter by tag */
  tag?: string[];
  /** Exclusive filter by tag */
  excludeTag?: string[];
  /** Filter by state */
  state?: IngestionState[];
  /**
   * ```asc``` or ```desc``` to order by
   *             ```createdAt``` timestamp
   */
  order?: SortOrder;
  /**
   * Field to order by
   * @default "createdAt"
   */
  orderBy?: string;
  /**
   * Only include recordings created before this timestamp (exclusive)
   * @format date-time
   */
  createdBefore?: string;
  /**
   * Only include recordings created at or after this timestamp (inclusive)
   * @format date-time
   */
  createdAfter?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface RecordingTrackGetTrackFrameListByTrackIdParams {
  /**
   * First frame
   * @format int64
   */
  firstFrameIndex?: number;
  /**
   * Max number of frames returned
   * @format int64
   */
  maxFrames?: number;
  /**
   * Only include frames created at or after this timestamp (inclusive)
   * @format int64
   */
  firstTimestamp?: number;
  /**
   * Only include frames created before this timestamp
   * @format int64
   */
  lastTimestamp?: number;
  /** A continuation token */
  continuationToken?: string;
  /** The device ID */
  deviceId: string;
  /** The recording ID */
  recordingId: string;
  /**
   * The track ID
   * @format int32
   */
  trackId: number;
}

export interface RecordingTrackGetTrackFrameListByNodePubParams {
  /**
   * First frame
   * @format int64
   */
  firstFrameIndex?: number;
  /**
   * maximum number of frames returned
   * @format int64
   */
  maxFrames?: number;
  /**
   * Only include frames created at or after this timestamp (inclusive)
   * @format int64
   */
  firstTimestamp?: number;
  /**
   * Only include frames created before this timestamp
   * @format int64
   */
  lastTimestamp?: number;
  /** A continuation token */
  continuationToken?: string;
  /** The device ID */
  deviceId: string;
  /** The recording ID */
  recordingId: string;
  /** The node name */
  nodeName: string;
  /** The publisher name */
  publisherName: string;
}

export interface RoomListsParams {
  /** Filter rooms by patient group ids */
  patientGroupIds?: string[];
  /** Filter rooms by site Id */
  siteId?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface SkinBookParams {
  /**
   * Inclusive
   * @format date-time
   */
  "createdAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "createdAtRange.end"?: string;
  /**
   * Limit results to scans that belong to a task group
   * If none, returns all scans that belong to Derma group
   */
  taskGroup?: TaskGroup;
  /**
   * Limit results to a patient
   * @format string
   */
  patientId?: string;
  /** Sort the scans by the createdAt timestamp */
  order?: SortOrder;
  /** Limit results to a specific type of scan. Default: "skin/1" */
  scanType?: string;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface UserGetProfilePhotoParams {
  /**
   * Height or width of the photo in pixels.
   * Allowed values are 48, 64, 96, 120, 240, 360, 432 and 504.
   * If omitted, the higest available resolution is returned.
   * @format int32
   */
  size?: number;
  /** Cur8 Uri of the user in the format cur8:user:{tenantId}:{objectId} */
  userUri: string;
}

export type UserSettingsPatchUserScopedSettingPayload = Operation[];

export type UserSettingsPatchAppScopedSettingPayload = Operation[];

export interface VisitGetsByPatientIdParams {
  /**
   * Inclusive
   * @format date-time
   */
  "startDateTimeOffsetRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "startDateTimeOffsetRange.end"?: string;
  /**
   * Inclusive
   * @format date-time
   */
  "endDateTimeOffsetRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "endDateTimeOffsetRange.end"?: string;
  /** Status of the visit to filter on */
  status?: VisitStatus;
  /** Sort the visits by the start time */
  order?: SortOrder;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * The patient who visited
   * @format string
   */
  patientId: string;
}

export interface VisitGetsParams {
  /**
   * Inclusive
   * @format date-time
   */
  "checkinStartTimestampRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "checkinStartTimestampRange.end"?: string;
  /**
   * Inclusive
   * @format date-time
   */
  "localStartTime.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "localStartTime.end"?: string;
  /** Sort the visits by the check-in process start timestamp */
  order?: SortOrder;
  /**
   * Filter by PatientId
   * @format string
   */
  patientId?: string;
  /**
   * Filter by SlotId
   * @format uuid
   */
  slotId?: string;
  /** Filter by RoomId */
  roomId?: string;
  /**
   * Filter by no show
   * TODO: Once all visits have a status, we can get rid of this
   */
  noShow?: boolean;
  /** Filter by status */
  status?: VisitStatus;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface VisitGetLastParams {
  /** @format date-time */
  recordingCreatedAtTimestamp?: string;
  roomId?: string;
}

export interface VisitSummaryListByPatientParams {
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /**
   * Limit the results to visit summaries on or after this date
   * @format date
   */
  visitDateAfter?: string;
  /**
   * Limit the results to visit summaries before this date
   * @format date
   */
  visitDateBefore?: string;
  /**
   * Limit the results to a specific visit
   * @format uuid
   */
  visitId?: string;
  /** Sort order to sort by visit date */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
  /**
   * The visited patient
   * @format string
   */
  patientId: string;
}

export interface VisitSummaryListParams {
  /** Patient group Ids to filter by */
  patientGroupIds?: string[];
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 100
   * @default 50
   */
  pageSize?: number;
  /**
   * Limit the results to visit summaries before this date
   * @format date
   */
  visitDateBefore?: string;
  /**
   * Limit the results to visit summaries on or after this date
   * @format date
   */
  visitDateAfter?: string;
  /**
   * Limit the results to a specific visit
   * @format uuid
   */
  visitId?: string;
  /** Sort order to sort by visit date */
  order?: SortOrder;
  /** A continuation token */
  continuationToken?: string;
}

export interface VisitTypeGetAllsParams {
  /** A continuation token */
  continuationToken?: string;
}
